import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  Navbar,
  Nav,
  NavItem,
  NavDropdown,
  MenuItem,
  InputGroup,
  Glyphicon,
  Image,
  ListGroup,
  ListGroupItem,
  Carousel,
  Tabs,
  Tab,
  Table,
  Well,
  Alert,
  Radio,
  Checkbox,
  Form,
} from "react-bootstrap";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createBrowserHistory } from "history";
import { withRouter, Link } from "react-router-dom";
import moment from "moment";
import ReactHtmlParser from "react-html-parser";
import isEmpty from "lodash.isempty";
import DatePicker from "react-date-picker";
import "./dashboard.scss";
import {
  getCartDetail,
  checkout,
  applyPromoCode,
  removePromoCode,
  storeCredit,
  getcharityList,
  getAllSiteCity,
  taxRate,
  getSearchState,
  CheckGuestEmail,
  RegGuestEmail,
} from "../../../redux/actions/frontActions";
import { getFrontPaymentSetting } from "../../../redux/actions/payemntSettingAction";

import logo from "../../../img/ddb-logo.png";
import { appConfig } from "../../../config/appConfig";
import { Notification } from "../../../components/notifications";
import { renderAlert, clearAlert } from "../../../redux/actions/alertsActions";
import NumberFormat from "react-number-format";

import languageConfig from "../../../config/languageConfig";
import Recaptcha from "react-recaptcha";
import Cookies from "universal-cookie";
import ReactAutocomplete from "react-autocomplete";

const cookies = new Cookies();

const PUSHER_EVENT = appConfig.PUSHER_EVENT || 'inv-event';
const PUSHER_CHANNEL = appConfig.PUSHER_CHANNEL || 'payvibe-channel';
const history = createBrowserHistory();

let cart = "",
  isLoading = false,
  voucherStatus = "",
  bidAmount = "";
("use strict");

let responseValue = "",
  responseMessage = "",
  responseStatus = "",
  xCoordinate = {},
  yCoordinate = {};
let sendAsGift = 0,
  recipientName = "",
  recipientEmail = "",
  personalMessage = "";

function Currency(props) {
  const cur = props.default_currency == "EUR" ? "€" : "$";
  return (
    <span className={props.className}>
      {props.default_lang == "en" ? cur : ""}
      {props.amount}
      {props.default_lang == "fr" ? cur : ""}
    </span>
  );
}

function useQuery() {
  return new URLSearchParams(history.location.search);
}
class Checkout extends Component {
  static contextTypes = {
    router: PropTypes.object,
  };
  constructor(props, context) {
    super(props, context);
    this.state = {
      index: 0,
      direction: null,
      cartError: "",
      paymentType: "",
      addressMethod: "shipping",
      show: false,
      alertMessage: "",
      soldqtystatus: false,
      msgType: "",
      paymentMethod: "",
      cardHolderFirstName: "",
      cardHolderLastName: "",
      cardNumber: "",
      cardMonth: "",
      cardYear: "",
      securityCode: "",
      address: "",
      city: "",
      state: "",
      zip: "",
      phone: "",
      setAddress: "",
      payResult: "",
      promocode: "",
      creditRemain: "",
      creditAmount: "",
      promoStatus: 0,
      environment: "",
      giftBillingInfo: false,
      giftFirstName: "",
      giftLastName: "",
      giftAddress: "",
      giftCity: "",
      giftState: "",
      giftZip: "",
      recipientName: "",
      recipientEmail: "",
      personalMessage: "",
      giftZipError: "",
      checkoutType: "",
      email: "",
      Confirmemail: "",
      dob: "",
      sameAsBillingAddress: 0,
      shippingFirstName: "",
      shippingLastName: "",
      shippingAddress: "",
      shippingCity: "",
      shippingState: "",
      shippingzip: "",
      shippingPhone: "",
      methodStatus: "",
      address2: "",
      shippingAddress2: "",
      hover: false,
      charity: "",
      charity_id: "",
      charityOption: "disable",
      payPalStatus: false,
      authorizenetStatus: false,
      stripeStatus: false,
      allow_store: "yes",
      promoApplied: 0,
      card_data: "",
      user_data: "",
      cardData: 1,
      saveCardData: 0,
      check_card: 0,
      showSaveCard: 0,
      chaseStatus: false,
      cityList: [],
      offerStatus: [],
      encryptCardNumber: "",
      stateChange: false,
      charity_name: "",
      multi_lang: "no",
      lang: "",
      default_lang: cookies.get("default_lang")
        ? cookies.get("default_lang")
        : "en",
      currency: "",
      symbol: "",
      show_shipable: "no",
      show_charity: "disable",
      holdDeals: "no",
      holdAuctions: "no",
      CheckoutDeal: "0",
      CheckoutNotes: "",
      OrderThanks: "",
      siteName: "",
      pickupFirstName: "",
      pickupLastName: "",
      sameAsBillingName: "0",
      willcall: "no",
      stateList: [],
      guestemail: false,
      assigned_city_ids: "",
      emailError: "",
      ConfirmemailError: "",
      ConfirmemailMsg: "",
      disablePromo: false,
      taxes: "disable",
      isGuest: "0",
      isVerified: false,
      gemail: "",
      password: "",
      confirm_password: "",
      gemailError: "",
      passwordError: "",
      confirm_passwordError: "",
      guestError: false,
      StatusGuestEmail: "",
      cityuid: "",
      siteId : '',
      isPusherActive: false,
      channel:  this.props.pusher.subscribe(PUSHER_CHANNEL),
      remaining_qty_obj : {},
      isValidateRemainingQty : true
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleRegSubmit = this.handleRegSubmit.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.handleCheckout = this.handleCheckout.bind(this);
    this.handlePaymentMethod = this.handlePaymentMethod.bind(this);
    this.validate = this.validate.bind(this);
    this.validate2 = this.validate2.bind(this);
    this.authorizePaySubmit = this.authorizePaySubmit.bind(this);
    this.applyPromoCode = this.applyPromoCode.bind(this);
    this.freeCheckout = this.freeCheckout.bind(this);
    this.handleStoreCredit = this.handleStoreCredit.bind(this);
    this.onChangeState = this.onChangeState.bind(this);
    this.verifyCallback = this.verifyCallback.bind(this);
    this.expiredCallback = this.expiredCallback.bind(this);
    this.onloadCallback = this.onloadCallback.bind(this);
  }
  onChangeStartDate = (selectedDate) => {
   
    if (selectedDate instanceof Date && !isNaN(selectedDate)) {
         this.setState({
           dob: selectedDate,
           dobError: false // Reset error state if a valid date is selected
         });
       } 
       else if(selectedDate  === null)
       {
        this.setState({
          dob: '',
          dobError: false // Reset error state if a valid date is selected
        });
       }
       else {
         // Handle invalid date (optional)
       //  console.error('Invalid date selected:', selectedDate);
      
         this.setState({
      
        dobError: true // Set error state to indicate invalid date
           
         });
    
       }
     };
    
  hoverOn = (e) => {
    this.setState({
      hover: true,
      hoverID: e.target.attributes.getNamedItem("data-id").value,
    });
  };

  hoverOff = (e) => {
    this.setState({
      hover: false,
      hoverID: e.target.attributes.getNamedItem("data-id").value,
    });
  };

  handleBillingInfo = (e) => {
    if (e.target.checked) {
      this.setState({ sameAsBillingAddress: 1 });
      this.setState({ giftBillingInfo: true });
    } else {
      this.setState({ sameAsBillingAddress: 0 });
      this.setState({ giftBillingInfo: false });
    }
  };

  handleCardData = (e) => {
    if (e.target.checked) {
      this.setState({ cardData: 0, showSaveCard: 1, saveCardData: 1 });
    } else {
      this.setState({ cardData: 1, showSaveCard: 0, saveCardData: 1 });
    }
  };

  creditCardValue = (e) => {
    if (e.target.value !== "") {
      let index = e.target.value;
      let data = this.state.card_data[index];
      let cardNumber = "XXXXXXXXXXXX" + data.cardNumber.toString().substr(-4);
      this.setState({
        cardNumber: cardNumber,
        encryptCardNumber: data.id,
        cardMonth: data.cardExpiryDate.substring(0, 2),
        cardYear: data.cardExpiryDate.substring(2, 4),
        cardNumberError: "",
        cardMonthError: "",
        cardYearError: "",
      });
    } else {
      this.setState({
        cardNumber: "",
        encryptCardNumber: "",
        cardMonth: "",
        cardYear: "",
      });
    }
  };

  handleSaveCardData = (e) => {
    if (e.target.checked) {
      this.setState({ saveCardData: 0 });
    } else {
      this.setState({ saveCardData: 1 });
    }
  };

  handleStoreCredit = (e) => {
    if (e.target.checked) {
      this.setState({ creditAmount: e.target.value });
    } else {
      this.setState({ creditAmount: "" });
    }
  };

  freeCheckout = (e) => {
    e.preventDefault();
    if (
      isEmpty(localStorage.getItem("user")) &&
      this.state.checkoutType == ""
    ) {
      this.handleShow();
      this.setState({ promoStatus: 0 });
      this.setState({
        alertMessage: languageConfig[this.state.default_lang].must_be_logged,
        msgType: "danger",
      });
    } else {
      const err = this.validate();
      let total = 0;
      if (!isEmpty(this.state.cart)) {
        this.state.cart.map((cart, index) => {
          total = parseFloat(total) + parseFloat(cart.total);
          return total;
        });
      }
      let storeCredit =
        this.state.creditAmount > total ? total : this.state.creditAmount;
      if (!err) {
        isLoading = true;
        let userKey = cookies.get("token");
        let referredBy = cookies.get("referredBy");
        let referredLink = cookies.get("referredLink");
        let cartDetail = this.state.cart;

        let shippingAddress = {
          first_name: this.state.shippingFirstName,
          last_name: this.state.shippingLastName,
          line_1: this.state.shippingAddress,
          line_2: this.state.shippingAddress2,
          city: this.state.shippingCity,
          state: this.state.shippingState,
          zip: this.state.shippingzip,
          phone: this.state.shippingPhone,
        };

        let setAddress = {
          first_name: this.state.cardHolderFirstName,
          last_name: this.state.cardHolderLastName,
          line_1: this.state.address,
          line_2: this.state.address2,
          city: this.state.city,
          state: this.state.state,
          zip: this.state.zip,
          cituid: this.state.assigned_city_ids,
        };

        let setGiftAddress = {
          first_name: this.state.giftFirstName,
          last_name: this.state.giftLastName,
          address: this.state.giftAddress,
          city: this.state.giftCity,
          state: this.state.giftState,
          zip: this.state.giftZip,
        };

        if (this.state.giftBillingInfo) {
          this.setState({ sameAsBillingAddress: 1 });
        }

        let responseText = {
          payer_id: "0",
           store_credit: storeCredit ? storeCredit : 0,
           amount: "0",
          email: this.state.email,
          dob: moment(this.state.dob).format("YYYY-MM-DD"),
          status: "success",
          currency: this.state.currency,
          assigned_city_ids: this.state.assigned_city_ids,
          token: "0",
          paymentMethod: "FREE",
          transaction_id: "0",
          userKey: userKey,
          billing_address: setAddress,
          shipping_address:
            this.state.sameAsBillingAddress == 1 ? setAddress : shippingAddress,
          items: cartDetail,
          referredBy: referredBy,
          referredLink: referredLink,
          recipientAddress: sendAsGift == 1 ? setGiftAddress : "",
          recipientName: this.state.recipientName
            ? this.state.recipientName
            : recipientName,
          recipientEmail: this.state.recipientEmail
            ? this.state.recipientEmail
            : recipientEmail,
          personalMessage: this.state.personalMessage
            ? this.state.personalMessage
            : personalMessage,
          sameAsBillingAddress: this.state.sameAsBillingAddress,
          charity_id: this.state.charity_id,
          lang: this.state.default_lang,
        };

        if (this.state.checkoutType == "guest") {
          isLoading = true;
          this.props.checkout(
            responseText,
            "payment/save-payment-detail-guest"
          );
        } else {
          isLoading = true;
          this.props.checkout(responseText, "payment/save-payment-detail");
        }
        this.handlePageChange(1);
      } else {
        isLoading = false;
      }
    }
  };

  removePromoCode = (e) => {
    e.preventDefault();
    isLoading = true;
    this.setState({ disablePromo: false });
    let cartTotal = 0;
    this.props.removePromoCode({
      userKey: cookies.get("token"),
      promoCode: this.state.promocode,
      lang: this.state.default_lang,
    });
  };

  applyPromoCode = (e) => {
    e.preventDefault();
    this.setState({ disablePromo: true });
    if (this.state.promocode) {
      isLoading = true;
      let cartTotal = 0.0;
      if (!isEmpty(this.state.cart)) {
        this.state.cart.map((cart, index) => {
          cartTotal = parseFloat(cartTotal) + parseFloat(cart.total);
          return cartTotal;
        });
      }

      this.props.applyPromoCode({
        userKey: cookies.get("token"),
        promoCode: this.state.promocode,
        lang: this.state.default_lang,
        using_store_credit: this.state.creditAmount > 0 ? "yes" : "no",
        store_amount: this.state.creditAmount,
        total_amount: cartTotal.toFixed(2) ? cartTotal.toFixed(2) : "",
        user_info: localStorage.getItem("user_id")
          ? localStorage.getItem("user_id")
          : this.state.email,
      });

      this.handlePageChange();
    } else {
      this.setState({ disablePromo: false });
      let isError = true;
      this.setState({ promocodeError: "red" });
    }
  };

  onloadCallback() {}

  verifyCallback = (res) => {
    if (res) {
      this.setState({
        isVerified: true,
      });
      this.setState({
        show: false,
        alertMessage: "",
        msgType: "",
        guestError: false,
      });
    }
  };

  expiredCallback() {
    this.setState({
      isVerified: false,
    });
  }

  handlePaymentMethod(e) {
    if (
      isEmpty(localStorage.getItem("user")) &&
      this.state.checkoutType == ""
    ) {
      this.handleShow();
      this.setState({ promoStatus: 0 });
      this.setState({
        alertMessage: languageConfig[this.state.default_lang].must_be_logged,
        msgType: "danger",
        methodStatus: e.target.value,
      });
      window.scrollTo(0, document.body.scrollHeight);
    } else {
      if (e.target.value === "paypal") {
        if (this.state.show_shipable == "no") {
          this.setState({ paymentMethod: e.target.value });
        } else {
          let valid = this.validate();
          if (valid) {
            this.setState({ paymentMethod: e.target.value });
          } else {
            this.setState({ paymentMethod: "" });
          }
        }
      } else {
        if (this.state.stateChange == false) {
          this.setState({
            paymentMethod: e.target.value,
            state:
              e.target.value == "card" || e.target.value == "payway"
                ? this.state.user_data.state
                : this.state.user_data.stateAbbr,
          });
        } else {
          this.setState({ paymentMethod: e.target.value });
        }
      }
    }
  }

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  handleCheckout() {
    if (
      isEmpty(localStorage.getItem("user")) &&
      this.state.checkoutType == ""
    ) {
      this.handleShow();
      this.setState({ promoStatus: 0 });
      this.setState({
        alertMessage: languageConfig[this.state.default_lang].must_be_logged,
        msgType: "danger",
      });
    } else {
    }
  }

  handleChange(e) {
    if (e.target.name == "shippingzip" && e.target.value.length > 3) {
      this.props.taxRate({
        zipcode: e.target.value,
        userKey: cookies.get("token"),
      });
    }
    if (this.state.sameAsBillingAddress == 1 && e.target.name == "zip") {
      this.props.taxRate({
        zipcode: e.target.value,
        userKey: cookies.get("token"),
      });
    }
    if (e.target.name == "promocode") {
      this.setState({ [e.target.name]: e.target.value.toUpperCase() });
    } else {
      this.setState({ [e.target.name]: e.target.value });
    }

    if (e.target.name == "state") {
      this.setState({ stateChange: true });
    }

    if (`${e.target.name}Error` !== "") {
      if (e.target.name == "cardNumber") {
        if (e.target.value.length < 15 || e.target.value.length > 16) {
          this.setState({ [`${e.target.name}Error`]: "red" });
        } else {
          this.setState({ [`${e.target.name}Error`]: "green" });
        }
      } else if (e.target.name == "cardMonth") {
        if (
          e.target.value.length !== 2 &&
          e.target.value < 1 &&
          e.target.value > 12
        ) {
          this.setState({ [`${e.target.name}Error`]: "red" });
        } else {
          this.setState({ [`${e.target.name}Error`]: "green" });
        }
      } else if (e.target.name == "cardYear") {
        if (e.target.value.length !== 2) {
          this.setState({ [`${e.target.name}Error`]: "red" });
        } else {
          this.setState({ [`${e.target.name}Error`]: "green" });
        }
      } else {
        this.setState({ [`${e.target.name}Error`]: "green" });
      }
    }
  }

  handlePageChange = (page) => {
    isLoading = true;

    if (!isEmpty(localStorage.getItem("user"))) {
      this.props.storeCredit();
    }
    let siteData = JSON.parse(localStorage.getItem("siteDDBStatus"));
    this.siteId = siteData.siteID;
    this.isPusherActive = (siteData.broadcasting && siteData.broadcasting == 'enable') ? true : false;
    if (
      siteData.default_city ||
      siteData.multi_lang == "yes" ||
      siteData.default_lang != this.state.default_lang
    ) {
      this.props.getFrontPaymentSetting({
        lang: cookies.get("default_lang")
          ? cookies.get("default_lang")
          : siteData.default_lang,
      });
      this.props.getCartDetail({ userKey: cookies.get("token"), lang: "fr" });
    } else {
      this.props.getFrontPaymentSetting({ lang: this.state.default_lang });
      this.props.getCartDetail({ userKey: cookies.get("token"), lang: "fr" });
    }
  };

  handleRegSubmit = (e) => {
    e.preventDefault();
    let IsValid = this.validate2();
    if (!IsValid) {
      this.props.RegGuestEmail({
        gemail: this.state.gemail,
        password: this.state.password,
      });
    }
  };


  componentWillMount() {
    sendAsGift = 0;
    let siteData = JSON.parse(localStorage.getItem("siteDDBStatus"));
    if (siteData) {
      if (
        siteData.default_city ||
        siteData.multi_lang == "yes" ||
        siteData.default_lang != this.state.default_lang
      ) {
        this.setState({
          multi_lang: siteData.multi_lang,
          lang: siteData.lang,
          default_lang: cookies.get("default_lang")
            ? cookies.get("default_lang")
            : siteData.default_lang,
          taxes: siteData.taxes ? siteData.taxes : "disable",
        });
      }
      this.setState({
        cityuid: siteData.default_city,
      });
      this.setState({
        taxes: siteData.taxes ? siteData.taxes : "disable",
      });
    }

    if (this.props.themeData) {
      if (this.props.themeData.button) {
        this.setState({
          button_color: this.props.themeData.button.button_color,
          mouseover_color: this.props.themeData.button.mouseover_color,
        });
      }
    }

    this.props.clearAlert();
    let siteUrl = window.location.pathname.split("/");
    let QueryString = new URLSearchParams(window.location.search);

    let userKeys = cookies.get("token");
    if (siteUrl["2"] && siteUrl["2"] == "PayPalPayment") {
      if (
        QueryString.get("success") &&
        (QueryString.get("paymentId") || QueryString.get("token")) &&
        userKeys &&
        QueryString.get("success") == "true"
      ) {
        isLoading = true;
        this.props.getFrontPaymentSetting({
          lang: cookies.get("default_lang")
            ? cookies.get("default_lang")
            : siteData.default_lang,
        });
        this.props.getCartDetail({
          userKey: cookies.get("token"),
          lang: cookies.get("default_lang"),
        });

        let responseValue = {
          userKey: userKeys,
          paymentId: QueryString.get("paymentId"),
          token: QueryString.get("token"),
          PayerID: QueryString.get("PayerID"),
          success: "true",
        };
        cookies.remove("token");
        this.props.checkout(responseValue, "payment/savepaypalpayment");
      } else {
        isLoading = true;

        this.props.getFrontPaymentSetting({
          lang: cookies.get("default_lang")
            ? cookies.get("default_lang")
            : siteData.default_lang,
        });
        this.props.getCartDetail({
          userKey: cookies.get("token"),
          lang: cookies.get("default_lang"),
        });

        let responseValue = {
          userKey: userKeys,
          paymentId: QueryString.get("paymentId"),
          token: QueryString.get("token"),
          PayerID: QueryString.get("PayerID"),
          success: "false",
        };
        cookies.remove("token");
        this.props.checkout(responseValue, "payment/savepaypalpayment");
        this.handleDismiss();
        this.handlePageChange(1);
        this.props.getAllSiteCity();
        this.props.getSearchState();
        this.props.getcharityList({
          assigned_city_ids: siteData.default_city ? siteData.default_city : "",
        });
        if (siteData) {
          this.setState({
            charityOption: siteData.charity,
            check_card: siteData.check_card,
            siteName: siteData.siteName,
            assigned_city_ids: siteData.default_city,
          });
        }
      }
    } else {
      this.handleDismiss();
      this.handlePageChange(1);
      this.props.getAllSiteCity();
      this.props.getSearchState();
      this.props.getcharityList({
        assigned_city_ids: siteData.default_city ? siteData.default_city : "",
      });
      if (siteData) {
        this.setState({
          charityOption: siteData.charity,
          check_card: siteData.check_card,
          siteName: siteData.siteName,
          assigned_city_ids: siteData.default_city,
        });
      }
    }
    this.props.getCartDetail({ userKey: cookies.get("token"), lang: "fr" });
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.taxdata != nextProps.taxdata) {
      if (nextProps.taxdata) {
        isLoading = false;
        if (nextProps.taxdata.response != "error") {
          this.setState({ cart: nextProps.taxdata.data });
        }
      }
    }

    if (nextProps.language) {
      this.setState({ default_lang: nextProps.language });
      if (nextProps.language != this.state.default_lang) {
        this.props.getFrontPaymentSetting({ lang: nextProps.language });
        this.props.getCartDetail({
          userKey: cookies.get("token"),
          lang: cookies.get("default_lang"),
        });
      }
    }

    if (nextProps.currency) {
      this.setState({ currency: nextProps.currency, symbol: nextProps.symbol });
    }

    if (nextProps.themeData) {
      if (nextProps.themeData.button) {
        this.setState({
          button_color: nextProps.themeData.button.button_color,
          mouseover_color: nextProps.themeData.button.mouseover_color,
        });
      }
      if (this.props.cityList != nextProps.cityList) {
        isLoading = false;
        if (nextProps.cityList) {
          this.setState({ cityList: nextProps.cityList.data });
        }
      }
    }
    // cart detail
    if (this.props.cartDetail != nextProps.cartDetail) {
      if (nextProps.cartDetail) {
        isLoading = false;
        if (cookies.get("affiliateID")) {
          let checkDealID = cookies.get("affiliateID");
          const newCart = nextProps.cartDetail.data.data.map((data, pidx) => {
            if (checkDealID.dealID !== data.dealID) return data;
            return { ...data, affiliated_by: checkDealID.affiliateID };
          });
          this.setState({ cart: newCart });
        } else {
          this.setState({ cart: nextProps.cartDetail.data.data });
        }

        // real time notification for deal quantity
        if(this.isPusherActive){
          let tmpCart = [...nextProps.cartDetail.data.data];
          let tmpRemQ = {...this.state.remaining_qty_obj};
          this.state.channel.bind(PUSHER_EVENT, (data) => {
            let tmpSiteId = (data.siteId) ? parseInt(data.siteId) : '';
            let tmpDealID = (data.dealID) ? data.dealID : '';  
            if(this.siteId == tmpSiteId){
              tmpCart.map(v => {
                if(v.dealID == tmpDealID){
                  let tmpQty = (data.quantity) ? parseInt(data.quantity) : 0;
                  tmpRemQ[tmpDealID] = tmpQty;
                  this.setState({remaining_qty_obj:tmpRemQ});
                  if(tmpQty <= 0){
                    this.setState({isValidateRemainingQty: false})
                  }
                }
                return {...v}
              });
            }
          }); 
        }
        
        if (nextProps.cartDetail.data.show_store == "no") {
          this.setState({
            allow_store: nextProps.promoStatus.allow_store,
            creditAmount: "",
          });
        }
        if (nextProps.cartDetail.data.holdDeals) {
          this.setState({ holdDeals: nextProps.cartDetail.data.holdDeals });
        }
        if (nextProps.cartDetail.data.holdAuctions) {
          this.setState({
            holdAuctions: nextProps.cartDetail.data.holdAuctions,
          });
        }

        if (nextProps.cartDetail.data.CheckoutDeal) {
          this.setState({
            CheckoutDeal: nextProps.cartDetail.data.CheckoutDeal,
          });
        }

        if (nextProps.cartDetail.data.show_shipable) {
          this.setState({
            show_shipable: nextProps.cartDetail.data.show_shipable,
          });
        }
        if (nextProps.cartDetail.data.show_willcall) {
          this.setState({ willcall: nextProps.cartDetail.data.show_willcall });
        }
        if (nextProps.cartDetail.data.show_charity) {
          this.setState({
            show_charity: nextProps.cartDetail.data.show_charity,
          });
        }
      } else {
        isLoading = false;
        cart = "empty";
      }
    }

    if (this.props.getCharity !== nextProps.getCharity) {
      isLoading = false;
      if (nextProps.getCharity) {
        this.setState({ charity: nextProps.getCharity });
      }
    }

    if (this.props.creditAmount != nextProps.creditAmount) {
      if (nextProps.creditAmount) {
        isLoading = false;

        this.setState({
          creditRemain: nextProps.creditAmount.data,
          card_data: nextProps.creditAmount.card_data,
          user_data: nextProps.creditAmount.user_data,
        });

        if (nextProps.creditAmount.user_data) {
          this.setState({
            address: nextProps.creditAmount.user_data.address1,
            address2: nextProps.creditAmount.user_data.address2,
            city: nextProps.creditAmount.user_data.addCity,
            state: nextProps.creditAmount.user_data.state,
            phone: nextProps.creditAmount.user_data.phone,
            zip: nextProps.creditAmount.user_data.zipcode,
            cardHolderFirstName: nextProps.creditAmount.user_data.firstName,
            cardHolderLastName: nextProps.creditAmount.user_data.lastName,
          });
        }
      }
    }

    // cart status
    if (this.props.cartStatus != nextProps.cartStatus) {
      if (nextProps.cartStatus) {
        isLoading = false;

        this.setState({ cartStatus: nextProps.cartStatus });
      }
    }

    if (this.props.cartError != nextProps.cartError) {
      if (nextProps.cartError) {
        this.setState({ promoStatus: 0 });
        responseValue = "";
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("warning", nextProps.cartError);

        isLoading = false;
      }
    }

    if (this.props.checkoutStatus != nextProps.checkoutStatus) {
      if (nextProps.checkoutStatus) {
        isLoading = false;
        this.setState({ promoStatus: 0 });
        if (nextProps.checkoutStatus.data.response == "error") {
          this.props.clearAlert();
          this.handleShow();
          this.props.renderAlert(
            "danger",
            nextProps.checkoutStatus.data.message
          );

          isLoading = false;
        } else if (nextProps.checkoutStatus.data.response == "payment") {
          this.props.clearAlert();

          isLoading = false;
          voucherStatus = "not-generated";
          responseValue = "";
          responseStatus = "";
          cookies.remove("token");
          this.handlePageChange(1);
        } else if (nextProps.checkoutStatus.data.response == "holdPayment") {
          this.props.clearAlert();

          isLoading = false;
          voucherStatus = "holdPayment";
          responseValue = "";
          responseStatus = "";
          cookies.remove("token");
          this.handlePageChange(1);
        } else if (nextProps.checkoutStatus.data.response == "auctionHold") {
          this.props.clearAlert();

          isLoading = false;
          voucherStatus = "auctionHold";
          bidAmount = nextProps.checkoutStatus.data.data.bidAmount
            ? nextProps.checkoutStatus.data.data.bidAmount
            : nextProps.checkoutStatus.data.bidAmount
            ? nextProps.checkoutStatus.data.bidAmount
            : "";
          responseValue = "";
          responseStatus = "";
          cookies.remove("token");
          this.handlePageChange(1);
        } else if (nextProps.checkoutStatus.data.response == "URL") {
          this.props.clearAlert();
          isLoading = true;
          if (nextProps.checkoutStatus.data.url) {
            window.location.href = nextProps.checkoutStatus.data.url;
          }
        } else if (nextProps.checkoutStatus.data.response == "success") {
          this.props.clearAlert();
          this.handleShow();
          this.props.renderAlert("success", "The payment was successful!");

          isLoading = false;
          voucherStatus = "generated";
          responseValue = "";
          responseStatus = "";
          cookies.remove("affiliateID");
          cookies.remove("token");
          this.handlePageChange(1);
          this.setState({
            offerStatus: nextProps.checkoutStatus.data.data.cart_data,
          });
          this.setState({
            isGuest:
              nextProps.checkoutStatus.data.data.payment_by &&
              nextProps.checkoutStatus.data.data.payment_by.userTypeID &&
              nextProps.checkoutStatus.data.data.payment_by.userTypeID == "8"
                ? 1
                : 0,
          });
        }
      }
    }

    if (this.props.promoError != nextProps.promoError) {
      if (nextProps.promoError) {
        this.setState({ promoStatus: 1, disablePromo: false });
        responseValue = "";
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("warning", nextProps.promoError);

        isLoading = false;
      }
    }

    if (this.props.promoStatus != nextProps.promoStatus) {
      if (nextProps.promoStatus) {
        this.props.clearAlert();
        this.handleShow();
        if (nextProps.promoStatus.response != "error") {
          this.props.renderAlert("success", nextProps.promoStatus.message);
        } else {
          this.props.renderAlert("danger", nextProps.promoStatus.message);
        }

        isLoading = false;
        if (nextProps.promoStatus.response != "error") {
          this.setState({
            promoStatus: 1,
            promoApplied: 1,
            disablePromo: false,
          });
          if (nextProps.promoStatus.allow_store == "no") {
            this.setState({
              allow_store: nextProps.promoStatus.allow_store,
              creditAmount: "",
            });
          }
        }
        this.handlePageChange();
      }
    }

    if (this.props.removeStatus != nextProps.removeStatus) {
      if (nextProps.removeStatus) {
        this.setState({ promoStatus: 0, allow_store: "yes", promoApplied: 0 });
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("success", nextProps.removeStatus.message);

        isLoading = false;
        this.handlePageChange();
      }
    }

    if (this.props.message !== nextProps.message) {
      this.handleShow();
      this.setState({
        alertMessage: nextProps.message,
        msgType: nextProps.alertType,
      });
    }
    if (nextProps.paymentSetting) {
      if (nextProps.paymentSetting.checkout) {
        this.setState({
          CheckoutNotes: nextProps.paymentSetting.checkout,
          OrderThanks: nextProps.paymentSetting.order_thanks,
        });
      }
    }
    if (this.props.paymentSetting !== nextProps.paymentSetting) {
      if (nextProps.paymentSetting) {
        let data = nextProps.paymentSetting.data;
        // if(nextProps.paymentSetting.checkout)
        // {
        //   this.setState({CheckoutNotes: nextProps.paymentSetting.checkout, OrderThanks: nextProps.paymentSetting.order_thanks});
        // } //Move to above..
        let checkStatus = false;
        if (data.environment == "live") {
          if (
            data.authorizeLiveLoginID != "" &&
            data.authorizeLiveTransactionKey != "" &&
            data.authorizeLiveLoginID != null &&
            data.authorizeLiveTransactionKey != null &&
            data.allowPaymentAuthCheckout == 1
          ) {
            checkStatus = true;
            this.setState({
              authorizenetStatus: true,
              authStatus: true,
              paymentMethod: "card",
            });
          }
          if (
            data.paypalLiveUsername != "" &&
            data.paypalLivePassword != "" &&
            data.paypalLiveSignature != "" &&
            data.paypalLiveUsername != null &&
            data.paypalLivePassword != null &&
            data.paypalLiveSignature != null &&
            data.allowPaymentPaypalCheckout == 1
          ) {
            if (checkStatus === true) {
              this.setState({ payPalStatus: true, paymentMethod: "card" });
            } else {
              this.setState({ payPalStatus: true, paymentMethod: "paypal" });
            }
          }
          if (
            data.Chase_live_bin != "" &&
            data.Chase_live_merchant_id != "" &&
            data.Chase_live_password != "" &&
            data.Chase_live_terminal_id != "" &&
            data.Chase_live_username != "" &&
            data.Chase_live_bin != null &&
            data.Chase_live_merchant_id != null &&
            data.Chase_live_password != null &&
            data.Chase_live_terminal_id != null &&
            data.Chase_live_username != null &&
            data.allowPaymentChaseCheckout == 1
          ) {
            if (checkStatus === true) {
              this.setState({ chaseStatus: true, paymentMethod: "card" });
            } else {
              this.setState({
                chaseStatus: true,
                paymentMethod: "chase",
                state: this.state.user_data.stateAbbr,
              });
            }
          }

          if (
            data.Payway_live_idDivision != "" &&
            data.Payway_live_idSource != "" &&
            data.Payway_live_password != "" &&
            data.Payway_live_url != "" &&
            data.Payway_live_username != "" &&
            data.Payway_live_idDivision != null &&
            data.Payway_live_idSource != null &&
            data.Payway_live_password != null &&
            data.Payway_live_url != null &&
            data.Payway_live_username != null &&
            data.allowPaymentPaywayCheckout == 1
          ) {
            if (checkStatus === true) {
              this.setState({ paywayStatus: true, paymentMethod: "card" });
            } else {
              this.setState({
                paywayStatus: true,
                paymentMethod: "payway",
                state: this.state.user_data.stateAbbr,
              });
            }
          }
          if (
            (data.stripeLiveSecretKey != "" ||
              data.stripeLiveConnectedAcc != "") &&
            (data.stripeLiveSecretKey != null ||
              data.stripeLiveConnectedAcc != null) &&
            data.allowPaymentStripeCheckout == 1
          ) {
            var counterLive = 0;

            if (data.allowPaymentAuthCheckout == 1) {
              counterLive = counterLive + 1;
            }
            if (data.allowPaymentPaypalCheckout == 1) {
              counterLive = counterLive + 1;
            }
            if (data.allowPaymentChaseCheckout == 1) {
              counterLive = counterLive + 1;
            }
            if (data.allowPaymentPaywayCheckout == 1) {
              counterLive = counterLive + 1;
            }

            if (counterLive >= 1) {
              checkStatus = true;
              this.setState({ stripeStatus: true, paymentMethod: "card" });
            } else {
              checkStatus = true;
              this.setState({ stripeStatus: true, paymentMethod: "stripe" });
            }

            //checkStatus = true;
            //this .setState({stripeStatus: true, paymentMethod: 'card'});
          }
        } else {
          if (
            data.authorizeSandBoxLoginID != "" &&
            data.authorizeSandBoxTransactionKey != "" &&
            data.authorizeSandBoxLoginID != null &&
            data.authorizeSandBoxTransactionKey != null &&
            data.allowPaymentAuthCheckout == 1
          ) {
            checkStatus = true;
            this.setState({
              authorizenetStatus: true,
              authStatus: true,
              paymentMethod: "card",
            });
          }
          if (
            data.paypalSandBoxUsername != "" &&
            data.paypalSandBoxPassword != "" &&
            data.paypalSandBoxSignature != "" &&
            data.paypalSandBoxUsername != null &&
            data.paypalSandBoxPassword != null &&
            data.paypalSandBoxSignature != null &&
            data.allowPaymentPaypalCheckout == 1
          ) {
            if (checkStatus === true) {
              this.setState({ payPalStatus: true, paymentMethod: "card" });
            } else {
              this.setState({ payPalStatus: true, paymentMethod: "paypal" });
            }
          }
          if (
            data.Chase_test_bin != "" &&
            data.Chase_test_merchant_id != "" &&
            data.Chase_test_password != "" &&
            data.Chase_test_terminal_id != "" &&
            data.Chase_test_username != "" &&
            data.Chase_test_bin != null &&
            data.Chase_test_merchant_id != null &&
            data.Chase_test_password != null &&
            data.Chase_test_terminal_id != null &&
            data.Chase_test_username != null &&
            data.allowPaymentChaseCheckout == 1
          ) {
            if (checkStatus === true) {
              this.setState({ chaseStatus: true, paymentMethod: "card" });
            } else {
              this.setState({
                chaseStatus: true,
                paymentMethod: "chase",
                state: this.state.user_data.stateAbbr,
              });
            }
          }

          if (
            data.Payway_sanbox_idDivision != "" &&
            data.Payway_sanbox_idSource != "" &&
            data.Payway_sanbox_password != "" &&
            data.Payway_sanbox_url != "" &&
            data.Payway_sanbox_username != "" &&
            data.Payway_sanbox_idDivision != null &&
            data.Payway_sanbox_idSource != null &&
            data.Payway_sanbox_password != null &&
            data.Payway_sanbox_url != null &&
            data.Payway_sanbox_username != null &&
            data.allowPaymentPaywayCheckout == 1
          ) {
            if (checkStatus === true) {
              this.setState({ paywayStatus: true, paymentMethod: "card" });
            } else {
              this.setState({ paywayStatus: true, paymentMethod: "payway" });
            }
          }
          if (
            (data.stripeSandboxSecretKey != "" ||
              data.stripeSandboxConnectedAcc != "") &&
            (data.stripeSandboxSecretKey != null ||
              data.stripeSandboxConnectedAcc != null) &&
            data.allowPaymentStripeCheckout == 1
          ) {
            var counter = 0;

            if (data.allowPaymentAuthCheckout == 1) {
              counter = counter + 1;
            }
            if (data.allowPaymentPaypalCheckout == 1) {
              counter = counter + 1;
            }
            if (data.allowPaymentChaseCheckout == 1) {
              counter = counter + 1;
            }
            if (data.allowPaymentPaywayCheckout == 1) {
              counter = counter + 1;
            }

            if (counter >= 1) {
              checkStatus = true;
              this.setState({ stripeStatus: true, paymentMethod: "card" });
            } else {
              checkStatus = true;
              this.setState({ stripeStatus: true, paymentMethod: "stripe" });
            }
          }
        }
        this.setState({
          guestCheckout: data.guestCheckout,
          referall: data.referall,
          environment: data.environment,
          paypalSandBoxUsername: data.paypalSandBoxUsername,
          paypalSandBoxPassword: data.paypalSandBoxPassword,
          paypalSandBoxSignature: data.paypalSandBoxSignature,
          paypalLiveUsername: data.paypalLiveUsername,
          paypalLivePassword: data.paypalLivePassword,
          paypalLiveSignature: data.paypalLiveSignature,
        });
      }
    }

    if (nextProps.StateList) {
      if (nextProps.StateList.data) {
        this.setState({ stateList: nextProps.StateList.data });
      } else {
        this.setState({ stateList: [] });
      }
    }

    if (nextProps.CheckEmail !== this.props.CheckEmail) {
      if (nextProps.CheckEmail) {
        if (nextProps.CheckEmail.response == "error") {
          this.handleShow();
          this.setState({
            alertMessage: nextProps.CheckEmail.message,
            msgType: "danger",
            guestemail: true,
          });
        } else {
          this.handleDismiss();
          this.setState({
            guestemail: false,
          });
        }
      } else {
      }
    }
    if (nextProps.StatusGuestEmail !== this.state.StatusGuestEmail) {
      if (nextProps.StatusGuestEmail) {
        this.setState({ StatusGuestEmail: nextProps.StatusGuestEmail });
        if (nextProps.StatusGuestEmail.response == "success") {
          this.setState({
            show: true,
            alertMessage: nextProps.StatusGuestEmail.message,
            msgType: "success",
            guestError: true,
          });
          if (this.state.isGuest == "1") {
            this.context.router.history.push(`/login`);
          }
        } else {
          this.setState({
            show: true,
            alertMessage: nextProps.StatusGuestEmail.message,
            msgType: "warning",
            guestError: true,
          });
        }
      }
    }

    if (nextProps.error !== this.state.error) {
      if (nextProps.error) {
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("warning", nextProps.cartError);
        this.setState({
          show: true,
          alertMessage: nextProps.cartError,
          msgType: "danger",
          guestError: true,
        });

        isLoading = false;
      }
    }
  }

  componentWillUpdate(nextProps, nextState) {
    if (this.state.cartDetail != nextState.cartDetail) {
      isLoading = false;
      if (nextState.cartDetail) {
        this.setState({ cart: nextState.cartDetail });
      }
    }
  }

  componentDidMount() {
    let siteData = JSON.parse(localStorage.getItem("siteDDBStatus"));
    let disableSubscriptionPopup = localStorage.getItem(
      "disableSubscriptionPopup"
    )
      ? localStorage.getItem("disableSubscriptionPopup")
      : false;
    let accessibleCities = localStorage.getItem("accessibleCities")
      ? JSON.parse(localStorage.getItem("accessibleCities"))
      : [];

    //alert(cookies.get('default_lang'));
    this.props.getCartDetail({
      userKey: cookies.get("token"),
      lang: cookies.get("default_lang"),
    });

    // alert("Footer default_lang"+siteData.default_lang);
    // alert("Footer multi_lang"+siteData.multi_lang);
    // alert("Footer lang"+siteData.lang);

    if (siteData) {
      if (siteData.default_city || siteData.multi_lang == "yes") {
        this.setState({
          multi_lang: siteData.multi_lang,
          lang: siteData.lang,
          default_lang: cookies.get("default_lang")
            ? cookies.get("default_lang")
            : siteData.default_lang,
        });
      }
    }

    if (siteData) {
      this.setState({ fontFamilies: siteData.font_families });
    }

    if (siteData) {
      this.setState({
        twitterPage: siteData.twitterPage,
        facebookPage: siteData.facebookPage,
        siteName: siteData.siteName,
        youtube_link: siteData.youtube_link,
        insta_link: siteData.insta_link,
      });
      let showCityPasswordFrom = true;
      if (
        siteData.password_protect == "active" &&
        this.props.match.path != "/login" &&
        this.props.match.path != "/register/"
      ) {
        const cityPasswordIndx = siteData.city_passwords.findIndex(
          (x) => x.cityID === siteData.default_city
        );
        const cityIndx = accessibleCities.findIndex(
          (x) => x.cityID === siteData.default_city
        );

        if (
          (cityIndx >= 0 && accessibleCities[cityIndx].status == true) ||
          cityPasswordIndx == -1
        ) {
          showCityPasswordFrom = false;
        }
        this.setState({ showCityPasswordFrom: showCityPasswordFrom });
      }
    }

    if (this.props.themeData) {
      this.setState({
        themeData: this.props.themeData,
      });

      if (this.props.themeData.menu_bar) {
        this.setState({
          menuBgStyles: {
            backgroundColor: this.props.themeData.menu_bar.menu_bar_color,
          },
        });
      } else {
        this.setState({
          menuBgStyles: {
            backgroundColor: "",
          },
        });
      }
      if (this.props.themeData.footer) {
        this.setState({
          footerBgStyles: {
            backgroundColor: this.props.themeData.footer.footer_color,
          },
          footerTextStyles: {
            color: this.props.themeData.footer.footer_text_color,
          },
          footer_social_link_color: {
            color: this.props.themeData.footer.footer_social_link_color,
          },
        });
      } else {
        this.setState({
          footerBgStyles: {
            backgroundColor: "",
          },
          footerTextStyles: {
            color: "",
          },
          footer_social_link_color: {
            color: "",
          },
        });
      }

      if (this.props.themeData.button) {
        this.setState({
          button_color: this.props.themeData.button.button_color,
          mouseover_color: this.props.themeData.button.mouseover_color,
        });
      } else {
        this.setState({
          button_color: "",
          mouseover_color: "",
        });
      }
    }
  }

  paymentStatus(message, status, responseText) {
    this.handleShow();
    if (this.state.checkoutType == "guest") {
      isLoading = true;
      this.props.checkout(responseText, "payment/save-payment-detail-guest");
    } else {
      isLoading = true;
      this.props.checkout(responseText, "payment/save-payment-detail");
    }

    // this.props.checkout(responseText);
    if (status == "danger") {
      this.setState({ promoStatus: 0 });
      this.setState({ alertMessage: message, msgType: status });
    } else {
      this.handlePageChange(1);
    }
  }

  validate = () => {
    xCoordinate = {};
    yCoordinate = {};
    let isError = false;
    const errors = {};

    if (
      isEmpty(localStorage.getItem("user")) &&
      this.state.checkoutType != "guest"
    ) {
      isError = true;
      window.scrollTo(0, 0);
    }

    if (this.state.checkoutType == "guest") {
      if (!this.state.email || this.state.guestemail) {
        isError = true;
        if (
          xCoordinate.key !== "emailError" &&
          document.querySelector("#emailError") &&
          document.querySelector("#emailError").getBoundingClientRect()
        ) {
          let x =
            window.scrollX +
            document.querySelector("#emailError").getBoundingClientRect().left;
          let y =
            window.scrollY +
            document.querySelector("#emailError").getBoundingClientRect().top -
            89;
          xCoordinate["emailError"] = x;
          yCoordinate["emailError"] = y;
        }
        this.setState({ emailError: "red" });
      }

      if (
        !this.state.Confirmemail ||
        this.state.Confirmemail != this.state.email
      ) {
        isError = true;
        if (
          xCoordinate.key !== "ConfirmemailError" &&
          document.querySelector("#ConfirmemailError") &&
          document.querySelector("#ConfirmemailError").getBoundingClientRect()
        ) {
          let x =
            window.scrollX +
            document.querySelector("#ConfirmemailError").getBoundingClientRect()
              .left;
          let y =
            window.scrollY +
            document.querySelector("#ConfirmemailError").getBoundingClientRect()
              .top -
            89;
          xCoordinate["ConfirmemailError"] = x;
          yCoordinate["ConfirmemailError"] = y;
        }
        this.setState({
          ConfirmemailError: "red",
          ConfirmemailMsg: "Confirm Email must be same as email.",
        });
      } else {
        this.setState({ ConfirmemailMsg: "" });
      }

      if (!this.state.dob) {
        isError = true;
        if (
          xCoordinate.key !== "dobError" &&
          document.querySelector("#dobError") &&
          document.querySelector("#dobError").getBoundingClientRect()
        ) {
          let x =
            window.scrollX +
            document.querySelector("#dobError").getBoundingClientRect().left;
          let y =
            window.scrollY +
            document.querySelector("#dobError").getBoundingClientRect().top -
            89;
          xCoordinate["dobError"] = x;
          yCoordinate["dobError"] = y;
        }
        this.setState({ dobError: "red" });
      }
    }

    if (
      (this.state.paymentMethod === "card" ||
        this.state.paymentMethod === "chase" ||
        this.state.paymentMethod === "payway" ||
        this.state.paymentMethod === "stripe") &&
      this.state.total > 0
    ) {
      if (!this.state.cardHolderFirstName) {
        isError = true;
        if (
          xCoordinate.key !== "cardHolderFirstNameError" &&
          document
            .querySelector("#cardHolderFirstNameError")
            .getBoundingClientRect()
        ) {
          let x =
            window.scrollX +
            document
              .querySelector("#cardHolderFirstNameError")
              .getBoundingClientRect().left;
          let y =
            window.scrollY +
            document
              .querySelector("#cardHolderFirstNameError")
              .getBoundingClientRect().top -
            89;
          xCoordinate["cardHolderFirstNameError"] = x;
          yCoordinate["cardHolderFirstNameError"] = y;
        }
        this.setState({ cardHolderFirstNameError: "red" });
      }

      if (!this.state.cardHolderLastName) {
        isError = true;
        if (
          xCoordinate.key !== "cardHolderLastNameError" &&
          document
            .querySelector("#cardHolderLastNameError")
            .getBoundingClientRect()
        ) {
          let x =
            window.scrollX +
            document
              .querySelector("#cardHolderLastNameError")
              .getBoundingClientRect().left;
          let y =
            window.scrollY +
            document
              .querySelector("#cardHolderLastNameError")
              .getBoundingClientRect().top -
            89;
          xCoordinate["cardHolderLastNameError"] = x;
          yCoordinate["cardHolderLastNameError"] = y;
        }
        this.setState({ cardHolderLastNameError: "red" });
      }

      if (!this.state.cardNumber) {
        isError = true;
        if (
          xCoordinate.key !== "cardNumberError" &&
          document.querySelector("#cardNumberError").getBoundingClientRect()
        ) {
          let x =
            window.scrollX +
            document.querySelector("#cardNumberError").getBoundingClientRect()
              .left;
          let y =
            window.scrollY +
            document.querySelector("#cardNumberError").getBoundingClientRect()
              .top -
            89;
          xCoordinate["cardNumberError"] = x;
          yCoordinate["cardNumberError"] = y;
        }
        this.setState({ cardNumberError: "red" });
      }

      let cardNumber = this.state.cardNumber;
      if (typeof cardNumber == "number") {
        cardNumber = cardNumber.toString();
      }

      if (
        (cardNumber.length > 16 || cardNumber.length < 15) &&
        document.querySelector("#cardNumberError").getBoundingClientRect()
      ) {
        isError = true;
        if (xCoordinate.key !== "cardNumberError") {
          let x =
            window.scrollX +
            document.querySelector("#cardNumberError").getBoundingClientRect()
              .left;
          let y =
            window.scrollY +
            document.querySelector("#cardNumberError").getBoundingClientRect()
              .top -
            89;
          xCoordinate["cardNumberError"] = x;
          yCoordinate["cardNumberError"] = y;
        }
        this.setState({ cardNumberError: "red" });
      } else {
        this.setState({ cardNumberError: "" });
      }

      if (!this.state.cardMonth) {
        isError = true;
        if (
          xCoordinate.key !== "cardMonthError" &&
          document.querySelector("#cardMonthError").getBoundingClientRect()
        ) {
          let x =
            window.scrollX +
            document.querySelector("#cardMonthError").getBoundingClientRect()
              .left;
          let y =
            window.scrollY +
            document.querySelector("#cardMonthError").getBoundingClientRect()
              .top -
            89;
          xCoordinate["cardMonthError"] = x;
          yCoordinate["cardMonthError"] = y;
        }
        this.setState({ cardMonthError: "red" });
      } else {
        this.setState({ cardMonthError: "" });
      }

      if (this.state.cardMonth.length !== 2) {
        isError = true;
        if (
          xCoordinate.key !== "cardMonthError" &&
          document.querySelector("#cardMonthError").getBoundingClientRect()
        ) {
          let x =
            window.scrollX +
            document.querySelector("#cardMonthError").getBoundingClientRect()
              .left;
          let y =
            window.scrollY +
            document.querySelector("#cardMonthError").getBoundingClientRect()
              .top -
            89;
          xCoordinate["cardMonthError"] = x;
          yCoordinate["cardMonthError"] = y;
        }
        this.setState({ cardMonthError: "red" });
      } else {
        this.setState({ cardMonthError: "" });
      }

      if (!this.state.cardYear) {
        isError = true;
        if (
          xCoordinate.key !== "cardYearError" &&
          document.querySelector("#cardYearError").getBoundingClientRect()
        ) {
          let x =
            window.scrollX +
            document.querySelector("#cardYearError").getBoundingClientRect()
              .left;
          let y =
            window.scrollY +
            document.querySelector("#cardYearError").getBoundingClientRect()
              .top -
            89;
          xCoordinate["cardYearError"] = x;
          yCoordinate["cardYearError"] = y;
        }
        this.setState({ cardYearError: "red" });
      } else {
        this.setState({ cardYearError: "" });
      }

      if (this.state.cardYear.length !== 2) {
        isError = true;
        if (
          xCoordinate.key !== "cardYearError" &&
          document.querySelector("#cardYearError").getBoundingClientRect()
        ) {
          let x =
            window.scrollX +
            document.querySelector("#cardYearError").getBoundingClientRect()
              .left;
          let y =
            window.scrollY +
            document.querySelector("#cardYearError").getBoundingClientRect()
              .top -
            89;
          xCoordinate["cardYearError"] = x;
          yCoordinate["cardYearError"] = y;
        }
        this.setState({ cardYearError: "red" });
      } else {
        this.setState({ cardYearError: "" });
      }

      if (!this.state.securityCode) {
        isError = true;
        if (
          xCoordinate.key !== "securityCodeError" &&
          document.querySelector("#securityCodeError").getBoundingClientRect()
        ) {
          let x =
            window.scrollX +
            document.querySelector("#securityCodeError").getBoundingClientRect()
              .left;
          let y =
            window.scrollY +
            document.querySelector("#securityCodeError").getBoundingClientRect()
              .top -
            89;
          xCoordinate["securityCodeError"] = x;
          yCoordinate["securityCodeError"] = y;
        }
        this.setState({ securityCodeError: "red" });
      } else {
        this.setState({ securityCodeError: "" });
      }
    }

    if (!this.state.address) {
      isError = true;
      if (
        xCoordinate.key !== "addressError" &&
        document.querySelector("#addressError").getBoundingClientRect()
      ) {
        let x =
          window.scrollX +
          document.querySelector("#addressError").getBoundingClientRect().left;
        let y =
          window.scrollY +
          document.querySelector("#addressError").getBoundingClientRect().top -
          89;
        xCoordinate["addressError"] = x;
        yCoordinate["addressError"] = y;
      }
      this.setState({ addressError: "red" });
    } else {
      this.setState({ addressError: "" });
    }

    if (!this.state.city) {
      isError = true;
      this.setState({ cityError: "red" });
    } else {
      this.setState({ cityError: "" });
    }

    if (!this.state.state || typeof this.state.state == undefined) {
      isError = true;
      if (
        xCoordinate.key !== "stateError" &&
        document.querySelector("#stateError").getBoundingClientRect()
      ) {
        let x =
          window.scrollX +
          document.querySelector("#stateError").getBoundingClientRect().left;
        let y =
          window.scrollY +
          document.querySelector("#stateError").getBoundingClientRect().top -
          89;
        xCoordinate["stateError"] = x;
        yCoordinate["stateError"] = y;
      }
      this.setState({ stateError: "red" });
    } else {
      this.setState({ stateError: "" });
    }

    if (!this.state.zip) {
      isError = true;
      if (
        xCoordinate.key !== "zipError" &&
        document.querySelector("#zipError").getBoundingClientRect()
      ) {
        let x =
          window.scrollX +
          document.querySelector("#zipError").getBoundingClientRect().left;
        let y =
          window.scrollY +
          document.querySelector("#zipError").getBoundingClientRect().top -
          89;
        xCoordinate["zipError"] = x;
        yCoordinate["zipError"] = y;
      }
      this.setState({ zipError: "red" });
    } else {
      this.setState({ zipError: "" });
    }

    if (!this.state.phone) {
      isError = true;
      if (
        xCoordinate.key !== "phoneError" &&
        document.querySelector("#phoneError").getBoundingClientRect()
      ) {
        let x =
          window.scrollX +
          document.querySelector("#phoneError").getBoundingClientRect().left;
        let y =
          window.scrollY +
          document.querySelector("#phoneError").getBoundingClientRect().top -
          89;
        xCoordinate["phoneError"] = x;
        yCoordinate["phoneError"] = y;
      }
      this.setState({ phoneError: "red" });
    } else {
      this.setState({ phoneError: "" });
    }

    if (sendAsGift == 1) {
      if (!this.state.giftBillingInfo) {
        if (!this.state.giftFirstName) {
          isError = true;
          if (
            xCoordinate.key !== "giftFirstNameError" &&
            document
              .querySelector("#giftFirstNameError")
              .getBoundingClientRect()
          ) {
            let x =
              window.scrollX +
              document
                .querySelector("#giftFirstNameError")
                .getBoundingClientRect().left;
            let y =
              window.scrollY +
              document
                .querySelector("#giftFirstNameError")
                .getBoundingClientRect().top -
              89;
            xCoordinate["giftFirstNameError"] = x;
            yCoordinate["giftFirstNameError"] = y;
          }
          this.setState({ giftFirstNameError: "red" });
        }

        if (!this.state.giftLastName) {
          isError = true;
          if (
            xCoordinate.key !== "giftLastNameError" &&
            document.querySelector("#giftLastNameError").getBoundingClientRect()
          ) {
            let x =
              window.scrollX +
              document
                .querySelector("#giftLastNameError")
                .getBoundingClientRect().left;
            let y =
              window.scrollY +
              document
                .querySelector("#giftLastNameError")
                .getBoundingClientRect().top -
              89;
            xCoordinate["giftLastNameError"] = x;
            yCoordinate["giftLastNameError"] = y;
          }
          this.setState({ giftLastNameError: "red" });
        }

        if (!this.state.giftAddress) {
          isError = true;
          if (
            xCoordinate.key !== "giftAddressError" &&
            document.querySelector("#giftAddressError").getBoundingClientRect()
          ) {
            let x =
              window.scrollX +
              document
                .querySelector("#giftAddressError")
                .getBoundingClientRect().left;
            let y =
              window.scrollY +
              document
                .querySelector("#giftAddressError")
                .getBoundingClientRect().top -
              89;
            xCoordinate["giftAddressError"] = x;
            yCoordinate["giftAddressError"] = y;
          }
          this.setState({ giftAddressError: "red" });
        }

        if (!this.state.giftCity) {
          isError = true;
          if (
            xCoordinate.key !== "giftCityError" &&
            document.querySelector("#giftCityError").getBoundingClientRect()
          ) {
            let x =
              window.scrollX +
              document.querySelector("#giftCityError").getBoundingClientRect()
                .left;
            let y =
              window.scrollY +
              document.querySelector("#giftCityError").getBoundingClientRect()
                .top -
              89;
            xCoordinate["giftCityError"] = x;
            yCoordinate["giftCityError"] = y;
          }
          this.setState({ giftCityError: "red" });
        }

        if (!this.state.giftState) {
          isError = true;
          if (
            xCoordinate.key !== "giftStateError" &&
            document.querySelector("#giftStateError").getBoundingClientRect()
          ) {
            let x =
              window.scrollX +
              document.querySelector("#giftStateError").getBoundingClientRect()
                .left;
            let y =
              window.scrollY +
              document.querySelector("#giftStateError").getBoundingClientRect()
                .top -
              89;
            xCoordinate["giftStateError"] = x;
            yCoordinate["giftStateError"] = y;
          }
          this.setState({ giftStateError: "red" });
        }

        if (!this.state.giftZip) {
          isError = true;
          if (
            xCoordinate.key !== "giftZipError" &&
            document.querySelector("#giftZipError").getBoundingClientRect()
          ) {
            let x =
              window.scrollX +
              document.querySelector("#giftZipError").getBoundingClientRect()
                .left;
            let y =
              window.scrollY +
              document.querySelector("#giftZipError").getBoundingClientRect()
                .top -
              89;
            xCoordinate["giftZipError"] = x;
            yCoordinate["giftZipError"] = y;
          }
          this.setState({ giftZipError: "red" });
        }
      }
    }

    // shipping address validation
    if (
      this.state.sameAsBillingAddress == 0 &&
      this.state.show_shipable == "yes" &&
      sendAsGift != 1
    ) {
      if (!this.state.shippingFirstName) {
        isError = true;
        if (
          xCoordinate.key !== "shippingFirstNameError" &&
          document
            .querySelector("#shippingFirstNameError")
            .getBoundingClientRect()
        ) {
          let x =
            window.scrollX +
            document
              .querySelector("#shippingFirstNameError")
              .getBoundingClientRect().left;
          let y =
            window.scrollY +
            document
              .querySelector("#shippingFirstNameError")
              .getBoundingClientRect().top -
            89;
          xCoordinate["shippingFirstNameError"] = x;
          yCoordinate["shippingFirstNameError"] = y;
        }
        this.setState({ shippingFirstNameError: "red" });
      }

      if (!this.state.shippingLastName) {
        isError = true;
        if (
          xCoordinate.key !== "shippingLastNameError" &&
          document
            .querySelector("#shippingLastNameError")
            .getBoundingClientRect()
        ) {
          let x =
            window.scrollX +
            document
              .querySelector("#shippingLastNameError")
              .getBoundingClientRect().left;
          let y =
            window.scrollY +
            document
              .querySelector("#shippingLastNameError")
              .getBoundingClientRect().top -
            89;
          xCoordinate["shippingLastNameError"] = x;
          yCoordinate["shippingLastNameError"] = y;
        }
        this.setState({ shippingLastNameError: "red" });
      }

      if (!this.state.shippingAddress) {
        isError = true;
        if (
          xCoordinate.key !== "shippingAddressError" &&
          document
            .querySelector("#shippingAddressError")
            .getBoundingClientRect()
        ) {
          let x =
            window.scrollX +
            document
              .querySelector("#shippingAddressError")
              .getBoundingClientRect().left;
          let y =
            window.scrollY +
            document
              .querySelector("#shippingAddressError")
              .getBoundingClientRect().top -
            89;
          xCoordinate["shippingAddressError"] = x;
          yCoordinate["shippingAddressError"] = y;
        }
        this.setState({ shippingAddressError: "red" });
      }

      if (!this.state.shippingCity) {
        isError = true;
        if (
          xCoordinate.key !== "shippingCityError" &&
          document.querySelector("#shippingCityError").getBoundingClientRect()
        ) {
          let x =
            window.scrollX +
            document.querySelector("#shippingCityError").getBoundingClientRect()
              .left;
          let y =
            window.scrollY +
            document.querySelector("#shippingCityError").getBoundingClientRect()
              .top -
            89;
          xCoordinate["shippingCityError"] = x;
          yCoordinate["shippingCityError"] = y;
        }
        this.setState({ shippingCityError: "red" });
      }

      if (!this.state.shippingState) {
        isError = true;
        if (
          xCoordinate.key !== "shippingStateError" &&
          document.querySelector("#shippingStateError").getBoundingClientRect()
        ) {
          let x =
            window.scrollX +
            document
              .querySelector("#shippingStateError")
              .getBoundingClientRect().left;
          let y =
            window.scrollY +
            document
              .querySelector("#shippingStateError")
              .getBoundingClientRect().top -
            89;
          xCoordinate["shippingStateError"] = x;
          yCoordinate["shippingStateError"] = y;
        }
        this.setState({ shippingStateError: "red" });
      }

      if (!this.state.shippingzip) {
        isError = true;
        if (
          xCoordinate.key !== "shippingzipError" &&
          document.querySelector("#shippingzipError").getBoundingClientRect()
        ) {
          let x =
            window.scrollX +
            document.querySelector("#shippingzipError").getBoundingClientRect()
              .left;
          let y =
            window.scrollY +
            document.querySelector("#shippingzipError").getBoundingClientRect()
              .top -
            89;
          xCoordinate["shippingzipError"] = x;
          yCoordinate["shippingzipError"] = y;
        }
        this.setState({ shippingzipError: "red" });
      }

      if (!this.state.shippingPhone) {
        isError = true;
        if (
          xCoordinate.key !== "shippingPhoneError" &&
          document.querySelector("#shippingPhoneError").getBoundingClientRect()
        ) {
          let x =
            window.scrollX +
            document
              .querySelector("#shippingPhoneError")
              .getBoundingClientRect().left;
          let y =
            window.scrollY +
            document
              .querySelector("#shippingPhoneError")
              .getBoundingClientRect().top -
            89;
          xCoordinate["shippingPhoneError"] = x;
          yCoordinate["shippingPhoneError"] = y;
        }
        this.setState({ shippingPhoneError: "red" });
      }
    }

    if (this.state.sameAsBillingName == 0 && this.state.willcall == "yes") {
      if (!this.state.pickupFirstName) {
        isError = true;
        if (
          xCoordinate.key !== "pickupFirstNameError" &&
          document
            .querySelector("#pickupFirstNameError")
            .getBoundingClientRect()
        ) {
          let x =
            window.scrollX +
            document
              .querySelector("#pickupFirstNameError")
              .getBoundingClientRect().left;
          let y =
            window.scrollY +
            document
              .querySelector("#pickupFirstNameError")
              .getBoundingClientRect().top -
            89;
          xCoordinate["pickupFirstNameError"] = x;
          yCoordinate["pickupFirstNameError"] = y;
        }
        this.setState({ pickupFirstNameError: "red" });
      }

      if (!this.state.pickupLastName) {
        isError = true;
        if (
          xCoordinate.key !== "pickupLastNameError" &&
          document.querySelector("#pickupLastNameError").getBoundingClientRect()
        ) {
          let x =
            window.scrollX +
            document
              .querySelector("#pickupLastNameError")
              .getBoundingClientRect().left;
          let y =
            window.scrollY +
            document
              .querySelector("#pickupLastNameError")
              .getBoundingClientRect().top -
            89;
          xCoordinate["pickupLastNameError"] = x;
          yCoordinate["pickupLastNameError"] = y;
        }
        this.setState({ pickupLastNameError: "red" });
      }
    }

    return isError;
  };

  validate2 = () => {
    xCoordinate = {};
    yCoordinate = {};
    let errMessage;
    let isError = false;
    if (!this.state.gemail) {
      isError = true;
      if (
        xCoordinate.key !== "gemailError" &&
        document.querySelector("#gemailError").getBoundingClientRect()
      ) {
        let x =
          window.scrollX +
          document.querySelector("#gemailError").getBoundingClientRect().left;
        let y =
          window.scrollY +
          document.querySelector("#gemailError").getBoundingClientRect().top -
          89;
        xCoordinate["gemailError"] = x;
        yCoordinate["gemailError"] = y;
      }
      this.setState({ gemailError: "red" });
    }

    if (!this.state.password) {
      isError = true;
      if (
        xCoordinate.key !== "passwordError" &&
        document.querySelector("#passwordError").getBoundingClientRect()
      ) {
        let x =
          window.scrollX +
          document.querySelector("#passwordError").getBoundingClientRect().left;
        let y =
          window.scrollY +
          document.querySelector("#passwordError").getBoundingClientRect().top -
          89;
        xCoordinate["passwordError"] = x;
        yCoordinate["passwordError"] = y;
      }
      this.setState({ passwordError: "red" });
    }

    if (
      !this.state.confirm_password ||
      this.state.confirm_password != this.state.password
    ) {
      isError = true;
      if (
        xCoordinate.key !== "confirm_passwordError" &&
        document.querySelector("#confirm_passwordError").getBoundingClientRect()
      ) {
        let x =
          window.scrollX +
          document
            .querySelector("#confirm_passwordError")
            .getBoundingClientRect().left;
        let y =
          window.scrollY +
          document
            .querySelector("#confirm_passwordError")
            .getBoundingClientRect().top -
          89;
        xCoordinate["confirm_passwordError"] = x;
        yCoordinate["confirm_passwordError"] = y;
      }
      this.setState({ confirm_passwordError: "red" });
    }

    if (
      !this.state.isVerified &&
      !(
        this.state.siteKey &&
        (this.state.siteKey == "qW9hV53Wl6RgpfJzDM95HiFlp5YC6EJt5+klJrhgaEk=" ||
          this.state.siteKey == "hEhNweI8U4TkdzJsZDU5JljMbQRZqbDbNnDM46hEBxE=")
      )
    ) {
      isError = true;
      errMessage = "Please verify that you are human.";
    }

    if (isError && errMessage != "") {
      this.setState({
        show: true,
        alertMessage: errMessage,
        msgType: "warning",
        guestError: true,
      });
      let x =
        window.scrollX +
        document.querySelector("#panelBodyMsg").getBoundingClientRect().left;
      let y =
        window.scrollY +
        document.querySelector("#panelBodyMsg").getBoundingClientRect().top -
        89;
      xCoordinate["panelBodyMsg"] = x;
      yCoordinate["panelBodyMsg"] = y;
    }

    return isError;
  };
  totalAmount(total) {
    const err = this.validate(); //(this.state.paymentMethod =='paypal' ? false : this.validate());

    if (!err) {
      isLoading = true;
    } else {
      isLoading = false;

      let arr = Object.values(yCoordinate);
      let min = Math.min(...arr);
      let yCoordinateKey = "",
        yCoordinateValue,
        xCoordinateValue;
      {
        Object.keys(yCoordinate).map((key) => {
          if (yCoordinate[key] === min && yCoordinateKey.length == 0) {
            yCoordinateValue = yCoordinate[key];
            yCoordinateKey = key;
          }
        });
      }
      if (yCoordinateKey.length > 0) {
        xCoordinateValue = xCoordinate[yCoordinateKey];
        window.scrollTo(xCoordinateValue, yCoordinateValue);
      }
    }
    this.setState({ total: total, flow: "process" });
  }

  authorizePaySubmit(e) {
    e.preventDefault();
    const err = this.validate(); //(this.state.paymentMethod =='paypal' ? false : this.validate());
    if (!err) {
      isLoading = true;
      let userKey = cookies.get("token");
      let referredBy = cookies.get("referredBy");
      let referredLink = cookies.get("referredLink");
      let total_amount = this.state.total;
      let cartDetail = this.state.cart;
      let cardNumber = this.state.cardNumber;
      let cardExpiryDate = this.state.cardMonth + this.state.cardYear;
      let email = this.state.email;
      let dob = this.state.dob;
      let encryptCardNumber = this.state.encryptCardNumber;

      let recipientNameData = this.state.recipientName
        ? this.state.recipientName
        : recipientName;
      let recipientEmailData = this.state.recipientEmail
        ? this.state.recipientEmail
        : recipientEmail;
      let personalMessageData = this.state.personalMessage
        ? this.state.personalMessage
        : personalMessage;
      if (this.state.giftBillingInfo) {
        this.setState({ sameAsBillingAddress: 1 });
      }
      let giftBillingInfo = this.state.sameAsBillingAddress;
      let shippingAddress = {
        first_name: this.state.shippingFirstName,
        last_name: this.state.shippingLastName,
        line_1: this.state.shippingAddress,
        line_2: this.state.shippingAddress2,
        city: this.state.shippingCity,
        state: this.state.shippingState,
        zip: this.state.shippingzip,
        phone: this.state.shippingPhone,
      };
      let setAddress = {
        first_name: this.state.cardHolderFirstName,
        last_name: this.state.cardHolderLastName,
        line_1: this.state.address,
        line_2: this.state.address2,
        city: this.state.city,
        state: this.state.state,
        zip: this.state.zip,
        phone: this.state.phone,
      };

      let setGiftAddress = {
        first_name: this.state.giftFirstName,
        last_name: this.state.giftLastName,
        address: this.state.giftAddress,
        city: this.state.giftCity,
        state: this.state.giftState,
        zip: this.state.giftZip,
      };

      let recipientAddressData = sendAsGift == 1 ? setGiftAddress : "";

      let store_credit = this.state.creditAmount ? this.state.creditAmount : 0;
      let checkDealID = cookies.get("affiliateID")
        ? cookies.get("affiliateID")
        : "";
      let responseValue = {
        store_credit: store_credit,
        amount: parseFloat(total_amount).toFixed(2),
        email: email,
        dob: moment(dob).format("YYYY-MM-DD"),
        affiliateID: cookies.get("affiliateID") ? checkDealID.affiliateID : "",
        currency: this.state.currency,
        assigned_city_ids: this.state.assigned_city_ids,
        paymentMethod:
          this.state.paymentMethod == "chase"
            ? "chasePaymentMethod"
            : this.state.paymentMethod == "stripe"
            ? "stripePaymentMethod"
            : this.state.paymentMethod == "payway"
            ? "paywayPaymentMethod"
            : this.state.paymentMethod == "paypal"
            ? "paypal"
            : "authorizenet",
        userKey: userKey,
        billing_address: setAddress,
        shipping_address:
          giftBillingInfo == 1
            ? setAddress
            : sendAsGift == 1
            ? recipientAddressData
            : shippingAddress,
        items: cartDetail,
        referredBy: referredBy,
        referredLink: referredLink,
        recipientAddress: this.state.giftBillingInfo
          ? setAddress
          : recipientAddressData,
        recipientName: recipientNameData,
        recipientEmail: recipientEmailData,
        personalMessage: personalMessage,
        sameAsBillingAddress: giftBillingInfo,
        cardNumber: cardNumber,
        encryptCardNumber: encryptCardNumber,
        cardExpiryDate: cardExpiryDate,
        securityCode: this.state.securityCode,
        charity_id: this.state.charity_id,
        saveCardData: this.state.saveCardData,
        lang: this.state.default_lang,
        pickupFirstName:
          this.state.sameAsBillingName == "0"
            ? this.state.pickupFirstName
            : this.state.cardHolderFirstName,
        pickupLastName:
          this.state.sameAsBillingName == "0"
            ? this.state.pickupFirstName
            : this.state.cardHolderLastName,
      };

      if (this.state.checkoutType == "guest") {
        isLoading = true;
        this.props.checkout(responseValue, "payment/save-payment-detail-guest");
      } else {
        isLoading = true;
        this.props.checkout(responseValue, "payment/save-payment-detail");
      }
    } else {
      isLoading = false;
      let arr = Object.values(yCoordinate);
      let min = Math.min(...arr);
      let yCoordinateKey = "",
        yCoordinateValue,
        xCoordinateValue;
      {
        Object.keys(yCoordinate).map((key) => {
          if (yCoordinate[key] === min && yCoordinateKey.length == 0) {
            yCoordinateValue = yCoordinate[key];
            yCoordinateKey = key;
          }
        });
      }
      if (yCoordinateKey.length > 0) {
        xCoordinateValue = xCoordinate[yCoordinateKey];
        window.scrollTo(xCoordinateValue, yCoordinateValue);
      }
    }
    /*else{
      if(isEmpty(localStorage.getItem("user")))
      {
        window.scrollTo(0, 0);
      }
    }*/
  }

  checkoutTypeStatus = (e) => {
    this.setState({
      checkoutType: "guest",
      paymentMethod: this.state.paymentMethod ? this.state.paymentMethod : "",
    });
  };

  handleGuestChange = (e) => {
    if (`${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "green" });
    }
    if (e.target.name == "email") {
      this.props.CheckGuestEmail({
        email: e.target.value,
        lang: this.state.default_lang,
      });
      this.setState({ ConfirmemailMsg: "" });
    }
    if (e.target.name == "Confirmemail") {
      this.setState({ ConfirmemailMsg: "" });
    }
    this.setState({ [e.target.name]: e.target.value });
  };
  sameAsBillingAddress = (e) => {
    if (e.target.checked) {
      if (this.state.zip) {
        isLoading = true;
        this.props.taxRate({
          zipcode: this.state.zip,
          userKey: cookies.get("token"),
        });
      }
      this.setState({ sameAsBillingAddress: 1 });
    } else {
      this.setState({ sameAsBillingAddress: 0 });
    }
  };

  sameAsBillingName = (e) => {
    if (e.target.checked) {
      this.setState({ sameAsBillingName: 1 });
    } else {
      this.setState({ sameAsBillingName: 0 });
    }
  };

  convertStringObjToArr = (attrObj) => {
    let objAttributes = JSON.parse(attrObj);
    let objArr = [];
    if (
      objAttributes &&
      objAttributes.attribute &&
      !isEmpty(objAttributes.attribute)
    ) {
      objArr = objAttributes.attribute;
    }
    return objArr;
  };

  renderAttributes = (attrData) => {
    let tmparray = [];
    let attrArray = Object.keys(attrData).map((aObj, aindex) => {
      tmparray.push({ name: aObj, data: attrData[aObj] });
    });
    return tmparray;
  };

  shouldComponentUpdate(nextProps, nextState) {
    // if (this.state.cart === nextState.cartDetail) {
    //     return false
    // }

    return true;
  }

  onChangeCharity = (e) => {
    this.setState({ charity_name: e.target.value });
    this.props.getcharityList({
      limit: 10,
      search: e.target.value,
      assigned_city_ids: this.state.assigned_city_ids,
    });
  };

  onChangeState = (e) => {
    this.setState({ stateName: e.target.value, state: "" });
    this.props.getSearchState({ search: e.target.value });
    let StateData = [];
    StateData = this.state.stateList.filter(
      (item) => item.state.toLowerCase() === e.target.value.toLowerCase()
    );
    if (StateData.length > 0) {
      this.setState({
        state: StateData[0].stateAbbr,
        stateError: "",
      });
    }
  };

  render() {
    const { index, direction, payResult } = this.state;
    let responseText = {};
    let cartItemPaypal = [];
    let userKey = cookies.get("token");
    let referredBy = cookies.get("referredBy");
    let referredLink = cookies.get("referredLink");
    let cartItem,
      i = 1,
      total = 0,
      subRetailPrice = 0,
      subOfferPrice = 0,
      subTotalShipping = 0,
      taxPerc = 0,
      subTotalQty = 0,
      subCartOfferPrice = 0,
      totalTax = 0;

    if (!isEmpty(this.state.offerStatus)) {
      cartItem = this.state.offerStatus.map((cart, index) => {
        total = parseFloat(total) + parseFloat(cart.total);
        subTotalQty = parseFloat(subTotalQty) + parseFloat(cart.quantity);
        subRetailPrice =
          parseFloat(subRetailPrice) + parseFloat(cart.retailPrice);
        subOfferPrice = parseFloat(subOfferPrice) + parseFloat(cart.offerPrice);
        taxPerc = parseFloat(taxPerc) + parseFloat(cart.tax);
        subTotalShipping =
          parseFloat(subTotalShipping) + parseFloat(cart.shipping);
        if (cart.sendAsGift == 1) {
          sendAsGift = cart.sendAsGift;
          recipientName = cart.recipientName;
          recipientEmail = cart.recipientEmail;
          personalMessage = cart.personalMessage;
        }
      });
    }

    if (!isEmpty(this.state.cart)) {
      cartItem = this.state.cart.map((cart, index) => {
        total = parseFloat(total) + parseFloat(cart.total);
        subTotalQty = parseFloat(subTotalQty) + parseFloat(cart.quantity);
        subRetailPrice =
          parseFloat(subRetailPrice) + parseFloat(cart.retailPrice);
        subOfferPrice = parseFloat(subOfferPrice) + parseFloat(cart.offerPrice);
        subCartOfferPrice =
          parseFloat(subCartOfferPrice) +
          parseFloat(cart.offerPrice) * parseFloat(cart.quantity);
        taxPerc = parseFloat(taxPerc) + parseFloat(cart.tax);
        subTotalShipping =
          parseFloat(subTotalShipping) + parseFloat(cart.shipping);
        totalTax =
          parseInt(totalTax) +
          parseFloat(cart.offerPrice) *
            parseFloat(cart.tax) *
            parseFloat(cart.quantity);
        cartItemPaypal.push({
          name: cart.dealText,
          price: cart.price,
          description: cart.termsAndConditions,
          quantity: cart.quantity,
          tax: cart.price * cart.tax * cart.quantity,
          currency: this.state.currency,
        });

        if (cart.sendAsGift == 1) {
          sendAsGift = cart.sendAsGift;
          recipientName = cart.recipientName;
          recipientEmail = cart.recipientEmail;
          personalMessage = cart.personalMessage;
        }
      });
    }

    let currency = this.state.currency; // or you can set this value from your props or state
    let env; // you can set here to 'production' for production
    if (this.state.environment == "sandbox") {
      env = "sandbox";
    } else {
      env = "production";
    }

    return (
      <div>
        {isLoading == true ? (
          <div className="loader">
            <p className="loading-message">
              {this.state.flow != "process" ? (
                <i>Loading...</i>
              ) : (
                <b
                  style={{
                    color: "rgb(255 255 255)",
                    fontSize: 18,
                    fontWeight: "normal",
                    fontStyle: "italic",
                  }}
                >
                  Order Processing...
                </b>
              )}
            </p>
            <div className="spinner">
              <div className="dot1" />
              <div className="dot2" />
            </div>
          </div>
        ) : (
          ""
        )}
        {/* {console.log(
          "this.state.cart",
          this.state.cart,
          "voucherStatus",
          voucherStatus
        )} */}
        {isEmpty(this.state.cart) && this.state.cart == "" ? (
          voucherStatus == "generated" ? (
            <div className="container margin-top">
              <Well bsSize="large" className="margin-top">
                {this.state.OrderThanks ? (
                  <React.Fragment>
                    {ReactHtmlParser(this.state.OrderThanks)}
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    {this.state.default_lang == "en" ? (
                      <React.Fragment>
                        <p>
                          Give our system just a few minutes to magically put
                          together your voucher and then you can find your
                          coupon code by accessing the MY ACCOUNT link at the
                          top of {window.location.host}.
                        </p>
                        <p>
                          All of your order history and certificate links are
                          located on this page. Please print and take the
                          coupon, with it's unique code, to the merchant
                          location to redeem within restrictions and prior to
                          expiration date.
                        </p>
                        <p>
                          You saved some major moolah, my friend. Feel good
                          about that! But, if you have any questions regarding
                          your deal, please contact us at support@
                          {window.location.host}.
                        </p>
                      </React.Fragment>
                    ) : (
                      <p>
                        Donnez quelques minutes à notre système pour générer
                        votre carte-cadeau. Vous pourrez ensuite trouver votre
                        code de coupon en cliquant sur le lien MON COMPTE situé
                        en haut de {window.location.host}. L'historique de vos
                        commandes et les liens de vos certificats se trouvent
                        sur cette page. Veuillez imprimer et apporter le coupon
                        à code unique chez le commerçant. Si vous avez des
                        questions concernant votre transaction, veuillez nous
                        contacter à support@{window.location.host}.
                      </p>
                    )}
                  </React.Fragment>
                )}
                <Table
                  striped
                  bordered
                  condensed
                  hover
                  className="margin-top cartgrid"
                >
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>{languageConfig[this.state.default_lang].offer}</th>
                      <th>{languageConfig[this.state.default_lang].qty}</th>
                      <th>
                        {languageConfig[this.state.default_lang].retail_price}
                      </th>
                      <th>
                        {languageConfig[this.state.default_lang].offer_price}
                      </th>
                      <th>
                        {languageConfig[this.state.default_lang].shipping}
                      </th>
                      {this.state.taxes == "enable" && (
                        <th>{languageConfig[this.state.default_lang].tax}</th>
                      )}
                      <th>{languageConfig[this.state.default_lang].total}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {!isEmpty(this.state.offerStatus)
                      ? (cartItem = this.state.offerStatus.map(
                          (cart, index) => (
                            <tr key={Math.random()}>
                              <td className="none">{i++}</td>
                              <td className="offer">
                                {ReactHtmlParser(
                                  cart.mainDealText +
                                    " (" +
                                    cart.merchantName +
                                    ")"
                                )}
                                {cart.ismulti == true ? (
                                  <p>{ReactHtmlParser(cart.dealText)}</p>
                                ) : (
                                  ""
                                )}
                                {!isEmpty(cart.cart_title) && (
                                  <div className="margin-top">
                                    Location : {cart.cart_title},{" "}
                                    {cart.cart_stateAbbr}, {cart.cart_country}{" "}
                                  </div>
                                )}
                                {!isEmpty(cart.cart_attributes) &&
                                  this.convertStringObjToArr(
                                    cart.cart_attributes
                                  ).map((attrData) => {
                                    return (
                                      <Row
                                        // className="margin-top"
                                        key={Math.random()}
                                      >
                                        <Col
                                          md={12}
                                          xs={12}
                                          key={Math.random()}
                                        >
                                          {this.renderAttributes(attrData).map(
                                            (gtyVal, qtyIndex) => {
                                              return (
                                                <div key={qtyIndex}>
                                                  <span
                                                    id="textSpan"
                                                    style={{
                                                      fontWeight: "bold",
                                                    }}
                                                  >
                                                    {gtyVal.name.replace(
                                                      /^"(.*)"$/,
                                                      "$1"
                                                    )}
                                                  </span>{" "}
                                                  :: {gtyVal.data}
                                                </div>
                                              );
                                            }
                                          )}
                                        </Col>
                                      </Row>
                                    );
                                  })}
                                {cart.termsAndConditions && (
                                  <React.Fragment>
                                    <hr />
                                    <b>
                                      {
                                        languageConfig[this.state.default_lang]
                                          .term
                                      }
                                      :
                                    </b>{" "}
                                    {ReactHtmlParser(cart.termsAndConditions)}
                                  </React.Fragment>
                                )}
                                {cart.checkoutNotes !== "" &&
                                  cart.checkoutNotes !== "null" && (
                                    <React.Fragment>
                                      <hr />
                                      <span className="text-danger">
                                        <b>
                                          {cart.checkoutNotes
                                            ? `${
                                                languageConfig[
                                                  this.state.default_lang
                                                ].note
                                              }: `
                                            : ""}
                                        </b>{" "}
                                        {cart.checkoutNotes}
                                      </span>
                                    </React.Fragment>
                                  )}
                              </td>
                              <td className="qty">
                                <div className="form-group">{cart.quantity}</div>
                                {(parseInt(this.state.remaining_qty_obj[cart.dealID]) >= 0) ? <span className="quantity-left">Quantity Left {this.state.remaining_qty_obj[cart.dealID]}</span> : ''}
                              </td>
                              <td className="rprice">
                                <Currency
                                  amount={cart.retailPrice}
                                  default_lang={this.state.default_lang}
                                  className=""
                                  default_currency={this.state.currency}
                                />
                              </td>
                              <td className="oprice">
                                <Currency
                                  amount={cart.offerPrice}
                                  default_lang={this.state.default_lang}
                                  className=""
                                  default_currency={this.state.currency}
                                />
                              </td>
                              <td className="shipping">
                                <Currency
                                  amount={cart.shipping}
                                  default_lang={this.state.default_lang}
                                  className=""
                                  default_currency={this.state.currency}
                                />
                              </td>
                              {this.state.taxes == "enable" && (
                                <td className="tax">{cart.tax}%</td>
                              )}
                              <td className="total">
                                <Currency
                                  amount={cart.total}
                                  default_lang={this.state.default_lang}
                                  className=""
                                  default_currency={this.state.currency}
                                />
                              </td>
                            </tr>
                          )
                        ))
                      : null}

                    {!isEmpty(this.state.cart) &&
                      this.state.cart.length > 1 && (
                        <tr>
                          <td className="none"></td>
                          <td className="pull-right none">
                            {languageConfig[this.state.default_lang].sub_total}
                          </td>
                          <td className="subqty">{subTotalQty}</td>
                          <td className="subrprice">
                            <Currency
                              amount={subRetailPrice.toFixed(2)}
                              default_lang={this.state.default_lang}
                              className=""
                              default_currency={this.state.currency}
                            />
                          </td>
                          <td className="text-center suboprice">
                            <Currency
                              amount={subOfferPrice.toFixed(2)}
                              default_lang={this.state.default_lang}
                              className=""
                              default_currency={this.state.currency}
                            />
                          </td>
                          <td className="subshipping">
                            <b>
                              <Currency
                                amount={subTotalShipping.toFixed(2)}
                                default_lang={this.state.default_lang}
                                className=""
                                default_currency={this.state.currency}
                              />
                            </b>
                          </td>
                          {this.state.taxes == "enable" && (
                            <td className="text-center suboprice">
                              {taxPerc.toFixed(2)}%
                            </td>
                          )}
                          <td className="total">
                            <b>
                              <Currency
                                amount={total.toFixed(2)}
                                default_lang={this.state.default_lang}
                                className=""
                                default_currency={this.state.currency}
                              />
                            </b>
                          </td>
                        </tr>
                      )}
                    <tr>
                      <td
                        className="none"
                        colSpan={this.state.taxes == "enable" ? 5 : 4}
                      />
                      <td colSpan="2" className="text-center none">
                        {languageConfig[this.state.default_lang].grand_total}
                      </td>
                      <td>
                        <b>
                          <Currency
                            amount={total.toFixed(2)}
                            default_lang={this.state.default_lang}
                            className=""
                            default_currency={this.state.currency}
                          />
                        </b>
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </Well>

              {/*-- Guest Registration Block On thank you..--*/}
              {this.state.isGuest == "1" && (
                <Well>
                  <span id="panelBodyMsg">
                    {this.state.show &&
                      this.state.alertMessage !== "" &&
                      this.state.alertMessage !== undefined &&
                      this.state.guestError && (
                        <div className="col-lg-12">
                          <Alert
                            bsStyle={this.state.msgType}
                            onDismiss={this.handleDismiss}
                          >
                            <strong>Message:</strong> {this.state.alertMessage}
                          </Alert>
                        </div>
                      )}
                  </span>
                  <Row>
                    <Col mdOffset={3} md={6} xs={12}>
                      <form
                        onSubmit={this.handleRegSubmit}
                        style={{ textAlign: "left" }}
                      >
                        <ControlLabel>
                          Register now to access your order history and follow
                          your package delivery.
                        </ControlLabel>
                        <Row>
                          <Col md={12} xs={12}>
                            <FormGroup controlId="gemailError">
                              <ControlLabel>
                                {languageConfig[this.state.default_lang].email}
                                <span style={{ color: "red" }}>*</span>
                              </ControlLabel>
                              <FormControl
                                type="text"
                                value={this.state.gemail}
                                placeholder={
                                  languageConfig[this.state.default_lang].email
                                }
                                onChange={this.handleChange}
                                style={{
                                  borderColor: this.state.gemailError,
                                }}
                                name="gemail"
                                autoComplete="off"
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col md={12} xs={12}>
                            <FormGroup controlId="passwordError">
                              <ControlLabel>
                                {
                                  languageConfig[this.state.default_lang]
                                    .password
                                }
                                <span style={{ color: "red" }}>*</span>
                              </ControlLabel>
                              <FormControl
                                type="password"
                                value={this.state.password}
                                placeholder={
                                  languageConfig[this.state.default_lang]
                                    .password
                                }
                                onChange={this.handleChange}
                                name="password"
                                style={{
                                  borderColor: this.state.passwordError,
                                }}
                                autoComplete="off"
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col md={12} xs={12}>
                            <FormGroup controlId="confirm_passwordError">
                              <ControlLabel>
                                {
                                  languageConfig[this.state.default_lang]
                                    .confirm_password
                                }
                                <span style={{ color: "red" }}>*</span>
                              </ControlLabel>
                              <FormControl
                                type="password"
                                value={this.state.confirm_password}
                                placeholder={
                                  languageConfig[this.state.default_lang]
                                    .confirm_password
                                }
                                onChange={this.handleChange}
                                name="confirm_password"
                                style={{
                                  borderColor: this.state.confirm_passwordError,
                                }}
                                autoComplete="off"
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col md={12} xs={12}>
                            <Recaptcha
                              sitekey={
                                this.props.captchaKey
                                  ? this.props.captchaKey
                                  : appConfig.reCaptcha.siteKey
                              }
                              render="explicit"
                              hl={cookies.get("default_lang")}
                              verifyCallback={this.verifyCallback}
                              onloadCallback={this.onloadCallback}
                              expiredCallback={this.expiredCallback}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col md={12} xs={12}>
                            <Button
                              bsStyle="success"
                              style={{
                                backgroundColor:
                                  this.state.hover &&
                                  this.state.hoverID == "register"
                                    ? this.state.mouseover_color
                                    : this.state.button_color
                                    ? this.state.button_color
                                    : "#77C84E",
                              }}
                              data-id={"register"}
                              onMouseEnter={this.hoverOn}
                              onMouseLeave={this.hoverOff}
                              type="submit"
                              disabled={this.state.disabled}
                            >
                              {
                                languageConfig[this.state.default_lang]
                                  .create_account
                              }
                            </Button>
                          </Col>
                        </Row>
                      </form>
                    </Col>
                  </Row>
                </Well>
              )}

              <Button
                style={{
                  backgroundColor:
                    this.state.hover && this.state.hoverID == "Continue Shoping"
                      ? this.state.mouseover_color
                      : this.state.button_color
                      ? this.state.button_color
                      : "#77C84E",
                }}
                data-id={"Continue Shoping"}
                onMouseEnter={this.hoverOn}
                onMouseLeave={this.hoverOff}
                bsStyle="success"
                type="submit"
                onClick={() => this.context.router.history.push(`/`)}
              >
                {languageConfig[this.state.default_lang].continue_shopping}
              </Button>
            </div>
          ) : voucherStatus == "not-generated" ? (
            <div className="container margin-top text-center">
              <Well bsSize="large" className="margin-top">
                <h1>
                  {languageConfig[this.state.default_lang].dublicate_user_key}
                </h1>
              </Well>
              <Button
                style={{
                  backgroundColor:
                    this.state.hover && this.state.hoverID == "Continue Shoping"
                      ? this.state.mouseover_color
                      : this.state.button_color
                      ? this.state.button_color
                      : "#77C84E",
                }}
                data-id={"Continue Shoping"}
                onMouseEnter={this.hoverOn}
                onMouseLeave={this.hoverOff}
                bsStyle="success"
                type="submit"
                onClick={() => this.context.router.history.push(`/`)}
              >
                {languageConfig[this.state.default_lang].continue_shopping}
              </Button>
            </div>
          ) : voucherStatus == "holdPayment" ? (
            <div className="container margin-top text-center">
              <Well bsSize="large" className="margin-top">
                <h1>
                  Thank you for your order. Your credit card has not yet been
                  charged, though you will see it in the Pending section of your
                  account. You will receive an email once the order is
                  confirmed. Share this deal with your friends.
                </h1>
              </Well>
              <Button
                style={{
                  backgroundColor:
                    this.state.hover && this.state.hoverID == "Continue Shoping"
                      ? this.state.mouseover_color
                      : this.state.button_color
                      ? this.state.button_color
                      : "#77C84E",
                }}
                data-id={"Continue Shoping"}
                onMouseEnter={this.hoverOn}
                onMouseLeave={this.hoverOff}
                bsStyle="success"
                type="submit"
                onClick={() => this.context.router.history.push(`/`)}
              >
                {languageConfig[this.state.default_lang].continue_shopping}
              </Button>
            </div>
          ) : voucherStatus == "auctionHold" ? (
            <div className="container margin-top text-center">
              <Well bsSize="large" className="margin-top">
                <h1>
                  You have successfully submitted your bid for{" "}
                  <b>
                    <Currency
                      amount={bidAmount}
                      default_lang={this.state.default_lang}
                      className=""
                      default_currency={this.state.currency}
                    />
                  </b>
                </h1>
                <h3>
                  Keep a close on eye on the auction as you may be outbid by
                  someone. If you are the highest bidder when the Auction
                  closes, we will then process the payment and notify you via
                  email. If you did not win, your card will not be charged.
                  Thanks and good luck.
                </h3>
              </Well>
              <Button
                style={{
                  backgroundColor:
                    this.state.hover && this.state.hoverID == "Continue Shoping"
                      ? this.state.mouseover_color
                      : this.state.button_color
                      ? this.state.button_color
                      : "#77C84E",
                }}
                data-id={"Continue Shoping"}
                onMouseEnter={this.hoverOn}
                onMouseLeave={this.hoverOff}
                bsStyle="success"
                type="submit"
                onClick={() => this.context.router.history.push(`/`)}
              >
                {languageConfig[this.state.default_lang].continue_shopping}
              </Button>
            </div>
          ) : (
            this.state.cart == "" && (
              <div className="container margin-top text-center">
                <Well bsSize="large" className="margin-top">
                  <h1>{languageConfig[this.state.default_lang].cart_page}</h1>
                </Well>
                <Button
                  style={{
                    backgroundColor:
                      this.state.hover &&
                      this.state.hoverID == "Continue Shoping"
                        ? this.state.mouseover_color
                        : this.state.button_color
                        ? this.state.button_color
                        : "#77C84E",
                  }}
                  data-id={"Continue Shoping"}
                  onMouseEnter={this.hoverOn}
                  onMouseLeave={this.hoverOff}
                  bsStyle="success"
                  type="submit"
                  onClick={() => this.context.router.history.push(`/`)}
                >
                  {languageConfig[this.state.default_lang].continue_shopping}
                </Button>
              </div>
            )
          )
        ) : (
          <form
            onSubmit={
              total - this.state.creditAmount > 0
                ? this.authorizePaySubmit
                : this.freeCheckout
            }
          >
            <div className="container">
              <div className="panel">
                <header className="panel-heading">
                  {languageConfig[this.state.default_lang].confirm_order_check}
                </header>
                <div className="panel-body">
                  {isEmpty(localStorage.getItem("user")) && (
                    <Row>
                      <Col md={12} xs={12} className="text-center">
                        <Button
                          style={{
                            backgroundColor:
                              this.state.hover && this.state.hoverID == "login"
                                ? this.state.mouseover_color
                                : "#77C84E",
                          }}
                          data-id={"login"}
                          onMouseEnter={this.hoverOn}
                          onMouseLeave={this.hoverOff}
                          bsStyle={
                            !this.state.checkoutType ? "success" : "danger"
                          }
                          onClick={() =>
                            this.context.router.history.push("/login")
                          }
                        >
                          {languageConfig[this.state.default_lang].login}
                        </Button>
                        {this.state.guestCheckout == "enable" && (
                          <React.Fragment>
                            - {languageConfig[this.state.default_lang].or} -
                            <Button
                              style={{
                                backgroundColor:
                                  this.state.hover &&
                                  this.state.hoverID == "guest"
                                    ? this.state.mouseover_color
                                    : this.state.button_color,
                              }}
                              data-id={"guest"}
                              onMouseEnter={this.hoverOn}
                              onMouseLeave={this.hoverOff}
                              onClick={this.checkoutTypeStatus}
                              bsStyle={
                                this.state.checkoutType ? "success" : "danger"
                              }
                            >
                              {
                                languageConfig[this.state.default_lang]
                                  .guest_checkout
                              }
                            </Button>
                          </React.Fragment>
                        )}
                        {this.state.guestCheckout == "enable" ? (
                          <p style={{ color: "red" }}>
                            Please login to {this.state.siteName} to create an
                            account, OR select guest checkout here, and complete
                            order below.
                          </p>
                        ) : (
                          <p style={{ color: "red" }}>
                            Please login to {this.state.siteName} to create an
                            account, and complete order below.
                          </p>
                        )}
                      </Col>
                    </Row>
                  )}
                  {/* Guest Container*/}
                  {this.state.checkoutType == "guest" && (
                    <div className="panel guest-panel">
                      <header className="panel-heading">
                        {languageConfig[this.state.default_lang].guest_checkout}
                      </header>
                      <div className="panel-body">
                        <Row>
                          <Col md={6} xs={12}>
                            <FormGroup controlId="emailError">
                              <ControlLabel>
                                {languageConfig[this.state.default_lang].email}
                              </ControlLabel>
                              <FormControl
                                type="text"
                                value={this.state.email}
                                placeholder={
                                  languageConfig[this.state.default_lang]
                                    .enter_email
                                }
                                onChange={this.handleGuestChange}
                                name="email"
                                style={{ borderColor: this.state.emailError }}
                              />
                            </FormGroup>
                            <FormGroup controlId="ConfirmemailError">
                              <ControlLabel>
                                {
                                  languageConfig[this.state.default_lang]
                                    .enter_confirm_email
                                }
                              </ControlLabel>
                              <FormControl
                                type="text"
                                value={this.state.Confirmemail}
                                placeholder={
                                  languageConfig[this.state.default_lang]
                                    .enter_confirm_email
                                }
                                onChange={this.handleGuestChange}
                                name="Confirmemail"
                                style={{
                                  borderColor: this.state.ConfirmemailError,
                                }}
                              />
                              <span
                                style={{ color: this.state.ConfirmemailError }}
                              >
                                {this.state.ConfirmemailMsg}
                              </span>
                            </FormGroup>
                          </Col>
                          <Col md={6} xs={12} id="dobError">
                            <FormGroup>
                              <ControlLabel>
                                {
                                  languageConfig[this.state.default_lang]
                                    .date_birth
                                }{" "}
                                (MM/DD/YYYY)
                              </ControlLabel>{" "}
                              <br />
                              <DatePicker
                                onChange={this.onChangeStartDate}
                                value={this.state.dob}
                                className={this.state.dobError ? "error" : ""}
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  )}
                  <Table
                    striped
                    bordered
                    condensed
                    hover
                    className={
                      "margin-top cartgrid " +
                      (this.state.default_lang == "en" ? " " : "badge-fr ")
                    }
                  >
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>{languageConfig[this.state.default_lang].offer}</th>
                        <th>{languageConfig[this.state.default_lang].qty}</th>
                        <th>
                          {languageConfig[this.state.default_lang].retail_price}
                        </th>
                        <th>
                          {languageConfig[this.state.default_lang].offer_price}
                        </th>
                        <th>
                          {languageConfig[this.state.default_lang].shipping}
                        </th>
                        {this.state.taxes == "enable" && (
                          <th>{languageConfig[this.state.default_lang].tax}</th>
                        )}
                        <th>{languageConfig[this.state.default_lang].total}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {!isEmpty(this.state.cart)
                        ? (cartItem = this.state.cart.map((cart, index) => (
                            <tr key={Math.random()}>
                              <td className="none">{i++}</td>
                              <td className="offer">
                                {ReactHtmlParser(
                                  cart.mainDealText +
                                    " (" +
                                    cart.merchantName +
                                    ")"
                                )}
                                {cart.ismulti == true ? (
                                  <p>{ReactHtmlParser(cart.dealText)}</p>
                                ) : (
                                  ""
                                )}
                                {!isEmpty(cart.cart_title) && (
                                  <div className="margin-top">
                                    {
                                      languageConfig[this.state.default_lang]
                                        .location
                                    }{" "}
                                    : {cart.cart_title}, {cart.cart_stateAbbr},{" "}
                                    {cart.cart_country}{" "}
                                  </div>
                                )}
                                {!isEmpty(cart.cart_attributes) &&
                                  this.convertStringObjToArr(
                                    cart.cart_attributes
                                  ).map((attrData) => {
                                    return (
                                      <Row
                                        // className="margin-top"
                                        key={Math.random()}
                                      >
                                        <Col
                                          md={12}
                                          xs={12}
                                          key={Math.random()}
                                        >
                                          {this.renderAttributes(attrData).map(
                                            (gtyVal, qtyIndex) => {
                                              return (
                                                <div key={qtyIndex}>
                                                  <span
                                                    id="textSpan"
                                                    style={{
                                                      fontWeight: "bold",
                                                    }}
                                                  >
                                                    {gtyVal.name.replace(
                                                      /^"(.*)"$/,
                                                      "$1"
                                                    )}
                                                  </span>{" "}
                                                  :: {gtyVal.data}
                                                </div>
                                              );
                                            }
                                          )}
                                        </Col>
                                      </Row>
                                    );
                                  })}
                                {cart.termsAndConditions && (
                                  <React.Fragment>
                                    <hr />
                                    <b>
                                      {
                                        languageConfig[this.state.default_lang]
                                          .term
                                      }
                                      :
                                    </b>{" "}
                                    {ReactHtmlParser(cart.termsAndConditions)}
                                  </React.Fragment>
                                )}
                                {cart.checkoutNotes !== "" &&
                                  cart.checkoutNotes !== "null" && (
                                    <React.Fragment>
                                      <hr />
                                      <span className="text-danger">
                                        <b>
                                          {cart.checkoutNotes
                                            ? `${
                                                languageConfig[
                                                  this.state.default_lang
                                                ].note
                                              }: `
                                            : ""}
                                        </b>{" "}
                                        {cart.checkoutNotes}
                                      </span>
                                    </React.Fragment>
                                  )}
                              </td>
                              <td className="qty">
                                <div className="form-group">{cart.quantity}</div>
                                {(parseInt(this.state.remaining_qty_obj[cart.dealID]) >= 0) ? <span className="quantity-left">Quantity Left {this.state.remaining_qty_obj[cart.dealID]}</span> : ''}
                              </td>
                              <td className="rprice">
                                <Currency
                                  amount={cart.retailPrice}
                                  default_lang={this.state.default_lang}
                                  className=""
                                  default_currency={this.state.currency}
                                />
                              </td>
                              <td className="oprice">
                                <Currency
                                  amount={cart.offerPrice}
                                  default_lang={this.state.default_lang}
                                  className=""
                                  default_currency={this.state.currency}
                                />
                              </td>
                              <td className="shipping">
                                <Currency
                                  amount={cart.shipping}
                                  default_lang={this.state.default_lang}
                                  className=""
                                  default_currency={this.state.currency}
                                />
                              </td>
                              {this.state.taxes == "enable" && (
                                <td className="tax">{cart.tax}%</td>
                              )}
                              <td className="total">
                                <Currency
                                  amount={cart.total}
                                  default_lang={this.state.default_lang}
                                  className=""
                                  default_currency={this.state.currency}
                                />
                              </td>
                            </tr>
                          )))
                        : null}

                      {!isEmpty(this.state.cart) &&
                        this.state.cart.length > 1 && (
                          <tr>
                            <td className="none"></td>
                            <td className="pull-right none">
                              {
                                languageConfig[this.state.default_lang]
                                  .sub_total
                              }
                            </td>
                            <td className="subqty">{subTotalQty}</td>
                            <td className="subrprice">
                              <Currency
                                amount={subRetailPrice.toFixed(2)}
                                default_lang={this.state.default_lang}
                                className=""
                                default_currency={this.state.currency}
                              />
                            </td>
                            <td className="text-center suboprice">
                              <Currency
                                amount={subOfferPrice.toFixed(2)}
                                default_lang={this.state.default_lang}
                                className=""
                                default_currency={this.state.currency}
                              />
                            </td>
                            <td className="subshipping">
                              <b>
                                <Currency
                                  amount={subTotalShipping.toFixed(2)}
                                  default_lang={this.state.default_lang}
                                  className=""
                                  default_currency={this.state.currency}
                                />
                              </b>
                            </td>
                            {this.state.taxes == "enable" && (
                              <td className="text-center subtax">
                                {taxPerc.toFixed(2)}%
                              </td>
                            )}
                            <td className="total">
                              <b>
                                <Currency
                                  amount={total.toFixed(2)}
                                  default_lang={this.state.default_lang}
                                  className=""
                                  default_currency={this.state.currency}
                                />
                              </b>
                            </td>
                          </tr>
                        )}
                      <tr>
                        <td
                          className="none"
                          colSpan={this.state.taxes == "enable" ? 5 : 4}
                        />
                        <td colSpan="2" className="text-center none">
                          {languageConfig[this.state.default_lang].grand_total}
                        </td>
                        <td>
                          <b>
                            <Currency
                              amount={total.toFixed(2)}
                              default_lang={this.state.default_lang}
                              className=""
                              default_currency={this.state.currency}
                            />
                          </b>
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </div>
              </div>
              {/* Promocode Container*/}
              <div className="panel">
                <div className="panel-body">
                  <Row>
                    <Col md={4} xs={12}>
                      <FormGroup controlId="formPromoCodeTitle">
                        <ControlLabel>
                          {
                            languageConfig[this.state.default_lang]
                              .have_promo_code
                          }
                        </ControlLabel>
                        <p>
                          {
                            languageConfig[this.state.default_lang]
                              .enter_save_even
                          }
                        </p>
                      </FormGroup>
                    </Col>
                    <Col md={3} xs={12}>
                      <FormGroup controlId="formCodeTitle">
                        {this.state.promoStatus == 0 && (
                          <p className="pull-right">
                            {
                              languageConfig[this.state.default_lang]
                                .promotional_code
                            }
                            :
                          </p>
                        )}
                      </FormGroup>
                    </Col>
                    <Col md={4} xs={12}>
                      {this.state.promoApplied == 0 ? (
                        <FormGroup controlId="promocodeError">
                          <FormControl
                            type="text"
                            value={this.state.promocode}
                            placeholder={
                              languageConfig[this.state.default_lang]
                                .enter_propmocode
                            }
                            onChange={this.handleChange}
                            name="promocode"
                            style={{ borderColor: this.state.promocodeError }}
                          />
                        </FormGroup>
                      ) : (
                        <p>
                          Applied promo code:{" "}
                          <b className="text-success">{this.state.promocode}</b>
                        </p>
                      )}
                      <span className="text-danger" style={{ display: "none" }}>
                        <b>
                          {this.state.allow_store == "no"
                            ? "Store credit cannot be used with this promo code."
                            : ""}
                        </b>
                      </span>
                    </Col>
                    <Col md={1} xs={12}>
                      {this.state.promoApplied == 0 ? (
                        <Button
                          style={{
                            backgroundColor:
                              this.state.hover && this.state.hoverID == "Apply"
                                ? this.state.mouseover_color
                                : this.state.button_color
                                ? this.state.button_color
                                : "#77C84E",
                          }}
                          data-id={"Apply"}
                          onMouseEnter={this.hoverOn}
                          onMouseLeave={this.hoverOff}
                          bsStyle="success"
                          onClick={this.applyPromoCode}
                          disabled={this.state.disablePromo}
                        >
                          {languageConfig[this.state.default_lang].apply}
                        </Button>
                      ) : (
                        <Button
                          style={{
                            backgroundColor:
                              this.state.hover && this.state.hoverID == "Apply"
                                ? this.state.mouseover_color
                                : this.state.button_color
                                ? this.state.button_color
                                : "#77C84E",
                          }}
                          data-id={"Apply"}
                          onMouseEnter={this.hoverOn}
                          onMouseLeave={this.hoverOff}
                          bsStyle="success"
                          onClick={this.removePromoCode}
                        >
                          {languageConfig[this.state.default_lang].remove}
                        </Button>
                      )}
                    </Col>
                  </Row>

                  {this.state.show &&
                    this.state.alertMessage !== "" &&
                    this.state.alertMessage !== undefined &&
                    this.state.promoStatus == 1 && (
                      <div className="col-lg-12">
                        <Alert
                          bsStyle={this.state.msgType}
                          onDismiss={this.handleDismiss}
                        >
                          <strong>Message:</strong>{" "}
                          {this.state.alertMessage
                            ? ReactHtmlParser(this.state.alertMessage)
                            : ""}
                        </Alert>
                      </div>
                    )}
                </div>
              </div>
              {/* Billing Container*/}
              {total > 0 ? (
                <div className="panel">
                  <header className="panel-heading">
                    {languageConfig[this.state.default_lang].biling_information}
                  </header>
                  <div className="panel-body">
                    {localStorage.getItem("user") &&
                    this.state.environment == "" ? (
                      <div className="col-lg-12">
                        <Alert bsStyle="danger">
                          <strong>Error:</strong> Please contact your website
                          administrator!
                          <span>
                            <br />
                            <strong>Note:</strong> Payment option is not
                            configured by website administrator.
                          </span>
                        </Alert>
                      </div>
                    ) : (
                      <Row>
                        <Col md={12} xs={12}>
                          {!isEmpty(localStorage.getItem("user")) &&
                          this.state.creditRemain > 0 &&
                          this.state.allow_store == "yes" ? (
                            <FormGroup>
                              <Checkbox
                                name="paymentType"
                                value={this.state.creditRemain}
                                onClick={this.handleStoreCredit}
                                inline
                              >
                                Use store credit? You have $
                                {this.state.creditRemain} that can be applied to
                                this purchase
                              </Checkbox>
                            </FormGroup>
                          ) : null}
                        </Col>
                        {total - this.state.creditAmount > 0 &&
                        this.state.payPalStatus == true &&
                        this.state.holdDeals ==
                          "no" /*&& this.state.CheckoutDeal=='0'*/ ? (
                          <Col md={12} xs={12}>
                            <FormGroup>
                              {this.state.paymentMethod == "paypal" ? (
                                <Radio
                                  name="paymentType"
                                  value="paypal"
                                  checked={true}
                                  required="required"
                                  onClick={this.handlePaymentMethod}
                                  inline
                                >
                                  {
                                    languageConfig[this.state.default_lang]
                                      .paypal_pay
                                  }{" "}
                                  (
                                  {
                                    languageConfig[this.state.default_lang]
                                      .total
                                  }{" "}
                                  {
                                    languageConfig[this.state.default_lang]
                                      .amount
                                  }{" "}
                                  :
                                  <Currency
                                    amount={(
                                      total - this.state.creditAmount
                                    ).toFixed(2)}
                                    default_lang={this.state.default_lang}
                                    className=""
                                    default_currency={this.state.currency}
                                  />
                                  )
                                </Radio>
                              ) : (
                                <Radio
                                  name="paymentType"
                                  value="paypal"
                                  onClick={this.handlePaymentMethod}
                                  inline
                                >
                                  {
                                    languageConfig[this.state.default_lang]
                                      .paypal_pay
                                  }{" "}
                                  (
                                  {
                                    languageConfig[this.state.default_lang]
                                      .total
                                  }{" "}
                                  {
                                    languageConfig[this.state.default_lang]
                                      .amount
                                  }
                                  :{" "}
                                  <Currency
                                    amount={(
                                      total - this.state.creditAmount
                                    )}
                                    default_lang={this.state.default_lang}
                                    className=""
                                    default_currency={this.state.currency}
                                  />
                                  )
                                </Radio>
                              )}
                            </FormGroup>
                          </Col>
                        ) : (
                          ""
                        )}
                        {total - this.state.creditAmount > 0 &&
                        this.state.authorizenetStatus == true ? (
                          <Col md={12} xs={12}>
                            <FormGroup>
                              {this.state.paymentMethod == "card" ? (
                                <Radio
                                  name="paymentType"
                                  value="card"
                                  required="required"
                                  checked={true}
                                  onClick={this.handlePaymentMethod}
                                  inline
                                >
                                  {
                                    languageConfig[this.state.default_lang]
                                      .credit_debit_pay
                                  }{" "}
                                  (
                                  {
                                    languageConfig[this.state.default_lang]
                                      .total
                                  }{" "}
                                  {
                                    languageConfig[this.state.default_lang]
                                      .amount
                                  }
                                  :{" "}
                                  <Currency
                                    amount={(
                                      total - this.state.creditAmount
                                    ).toFixed(2)}
                                    default_lang={this.state.default_lang}
                                    className=""
                                    default_currency={this.state.currency}
                                  />
                                  )
                                </Radio>
                              ) : (
                                <Radio
                                  name="paymentType"
                                  value="card"
                                  onClick={this.handlePaymentMethod}
                                  inline
                                >
                                  {
                                    languageConfig[this.state.default_lang]
                                      .credit_debit_pay
                                  }{" "}
                                  (
                                  {
                                    languageConfig[this.state.default_lang]
                                      .total
                                  }{" "}
                                  {
                                    languageConfig[this.state.default_lang]
                                      .amount
                                  }
                                  :{" "}
                                  <Currency
                                    amount={(
                                      total - this.state.creditAmount
                                    ).toFixed(2)}
                                    default_lang={this.state.default_lang}
                                    className=""
                                    default_currency={this.state.currency}
                                  />
                                  )
                                </Radio>
                              )}
                            </FormGroup>
                          </Col>
                        ) : (
                          ""
                        )}
                        {total - this.state.creditAmount > 0 &&
                        this.state.chaseStatus == true &&
                        this.state.holdDeals == "no" &&
                        this.state.holdAuctions == "no" &&
                        this.state.CheckoutDeal == "0" ? (
                          <Col md={12} xs={12}>
                            <FormGroup>
                              {this.state.paymentMethod == "chase" ? (
                                <Radio
                                  name="paymentType"
                                  value="chase"
                                  required="required"
                                  checked={true}
                                  onClick={this.handlePaymentMethod}
                                  inline
                                >
                                  {
                                    languageConfig[this.state.default_lang]
                                      .chase_pay
                                  }{" "}
                                  (
                                  {
                                    languageConfig[this.state.default_lang]
                                      .total
                                  }{" "}
                                  {
                                    languageConfig[this.state.default_lang]
                                      .amount
                                  }
                                  :{" "}
                                  <Currency
                                    amount={(
                                      total - this.state.creditAmount
                                    ).toFixed(2)}
                                    default_lang={this.state.default_lang}
                                    className=""
                                    default_currency={this.state.currency}
                                  />
                                  )
                                </Radio>
                              ) : (
                                <Radio
                                  name="paymentType"
                                  value="chase"
                                  onClick={this.handlePaymentMethod}
                                  inline
                                >
                                  {
                                    languageConfig[this.state.default_lang]
                                      .chase_pay
                                  }{" "}
                                  (
                                  {
                                    languageConfig[this.state.default_lang]
                                      .total
                                  }{" "}
                                  {
                                    languageConfig[this.state.default_lang]
                                      .amount
                                  }
                                  :{" "}
                                  <Currency
                                    amount={(
                                      total - this.state.creditAmount
                                    ).toFixed(2)}
                                    default_lang={this.state.default_lang}
                                    className=""
                                    default_currency={this.state.currency}
                                  />
                                  )
                                </Radio>
                              )}
                            </FormGroup>
                          </Col>
                        ) : (
                          ""
                        )}

                        {/*------------ Start PayWay Payment ---------------*/}
                        {total - this.state.creditAmount > 0 &&
                        this.state.paywayStatus == true &&
                        this.state.CheckoutDeal == "0" ? (
                          <Col md={12} xs={12}>
                            <FormGroup>
                              {this.state.paymentMethod == "payway" ? (
                                <Radio
                                  name="paymentType"
                                  value="payway"
                                  required="required"
                                  checked={true}
                                  onClick={this.handlePaymentMethod}
                                  inline
                                >
                                  {
                                    languageConfig[this.state.default_lang]
                                      .payway_pay
                                  }{" "}
                                  (
                                  {
                                    languageConfig[this.state.default_lang]
                                      .total
                                  }{" "}
                                  {
                                    languageConfig[this.state.default_lang]
                                      .amount
                                  }
                                  :{" "}
                                  <Currency
                                    amount={(
                                      total - this.state.creditAmount
                                    ).toFixed(2)}
                                    default_lang={this.state.default_lang}
                                    className=""
                                    default_currency={this.state.currency}
                                  />
                                  )
                                </Radio>
                              ) : (
                                <Radio
                                  name="paymentType"
                                  value="payway"
                                  onClick={this.handlePaymentMethod}
                                  inline
                                >
                                  {
                                    languageConfig[this.state.default_lang]
                                      .payway_pay
                                  }{" "}
                                  (
                                  {
                                    languageConfig[this.state.default_lang]
                                      .total
                                  }{" "}
                                  {
                                    languageConfig[this.state.default_lang]
                                      .amount
                                  }
                                  :{" "}
                                  <Currency
                                    amount={(
                                      total - this.state.creditAmount
                                    ).toFixed(2)}
                                    default_lang={this.state.default_lang}
                                    className=""
                                    default_currency={this.state.currency}
                                  />
                                  )
                                </Radio>
                              )}
                            </FormGroup>
                          </Col>
                        ) : (
                          ""
                        )}
                        {/*------------ End PayWay Payment ---------------*/}

                        {/*------------ Start Stripe Payment Gateway ---------------*/}
                        {total - this.state.creditAmount > 0 &&
                        this.state.stripeStatus == true &&
                        this.state.holdDeals == "no" ? (
                          <Col md={12} xs={12}>
                            <FormGroup>
                              {this.state.paymentMethod == "stripe" ? (
                                <Radio
                                  name="paymentType"
                                  value="stripe"
                                  required="required"
                                  checked={true}
                                  onClick={this.handlePaymentMethod}
                                  inline
                                >
                                  {
                                    languageConfig[this.state.default_lang]
                                      .stripe_pay
                                  }{" "}
                                  (
                                  {
                                    languageConfig[this.state.default_lang]
                                      .total
                                  }{" "}
                                  {
                                    languageConfig[this.state.default_lang]
                                      .amount
                                  }
                                  :{" "}
                                  <Currency
                                    amount={(
                                      total - this.state.creditAmount
                                    ).toFixed(2)}
                                    default_lang={this.state.default_lang}
                                    className=""
                                    default_currency={this.state.currency}
                                  />
                                  )
                                </Radio>
                              ) : (
                                <Radio
                                  name="paymentType"
                                  value="stripe"
                                  onClick={this.handlePaymentMethod}
                                  inline
                                >
                                  {
                                    languageConfig[this.state.default_lang]
                                      .stripe_pay
                                  }{" "}
                                  (
                                  {
                                    languageConfig[this.state.default_lang]
                                      .total
                                  }{" "}
                                  {
                                    languageConfig[this.state.default_lang]
                                      .amount
                                  }
                                  :{" "}
                                  <Currency
                                    amount={(
                                      total - this.state.creditAmount
                                    ).toFixed(2)}
                                    default_lang={this.state.default_lang}
                                    className=""
                                    default_currency={this.state.currency}
                                  />
                                  )
                                </Radio>
                              )}
                            </FormGroup>
                          </Col>
                        ) : (
                          ""
                        )}
                        {/*------------ End Stripe Payment Gateway ---------------*/}
                        {(this.state.paymentMethod === "card" ||
                          this.state.paymentMethod === "chase" ||
                          this.state.paymentMethod === "payway" ||
                          this.state.paymentMethod === "paypal" ||
                          this.state.paymentMethod === "stripe") &&
                        total - this.state.creditAmount > 0 ? (
                          <Col md={12} xs={12}>
                            {this.state.paymentMethod === "card" ||
                            this.state.paymentMethod === "chase" ||
                            this.state.paymentMethod === "payway" ||
                            this.state.paymentMethod === "stripe" ? (
                              <React.Fragment>
                                <Row>
                                  {this.state.card_data !== "" &&
                                    this.state.check_card == 1 && (
                                      <Col md={12} xs={12}>
                                        <Form inline>
                                          <FormGroup>
                                            <ControlLabel>
                                              <Checkbox
                                                name="carData"
                                                onClick={this.handleCardData}
                                                inline
                                              >
                                                {
                                                  languageConfig[
                                                    this.state.default_lang
                                                  ].existing_credit_car
                                                }
                                              </Checkbox>
                                            </ControlLabel>{" "}
                                            {this.state.cardData == 0 && (
                                              <FormControl
                                                onChange={this.creditCardValue}
                                                componentClass="select"
                                                placeholder="select"
                                              >
                                                <option value="">select</option>
                                                {this.state.card_data.map(
                                                  (card, index) => (
                                                    <option value={index}>
                                                      {"XXXXXXXXXXXX" +
                                                        card.cardNumber
                                                          .toString()
                                                          .substr(-4)}
                                                    </option>
                                                  )
                                                )}
                                              </FormControl>
                                            )}
                                          </FormGroup>{" "}
                                        </Form>
                                        <br />
                                      </Col>
                                    )}
                                  {this.state.check_card == 1 &&
                                    this.state.showSaveCard == 0 && (
                                      <Col md={12} xs={12}>
                                        <Form inline>
                                          <FormGroup>
                                            <ControlLabel>
                                              <Checkbox
                                                name="saveCardData"
                                                defaultChecked={
                                                  this.state.saveCardData == 0
                                                    ? true
                                                    : false
                                                }
                                                onClick={
                                                  this.handleSaveCardData
                                                }
                                                inline
                                              >
                                                {" "}
                                                {
                                                  languageConfig[
                                                    this.state.default_lang
                                                  ].store_billing
                                                }
                                              </Checkbox>
                                            </ControlLabel>{" "}
                                          </FormGroup>
                                        </Form>
                                        <br />
                                      </Col>
                                    )}
                                  <Col md={6} xs={12}>
                                    <FormGroup controlId="cardHolderFirstNameError">
                                      <ControlLabel>
                                        {
                                          languageConfig[
                                            this.state.default_lang
                                          ].cardholder_fname
                                        }{" "}
                                      </ControlLabel>
                                      <FormControl
                                        type="text"
                                        value={this.state.cardHolderFirstName}
                                        placeholder={
                                          languageConfig[
                                            this.state.default_lang
                                          ].enter_first_name
                                        }
                                        onChange={this.handleChange}
                                        style={{
                                          borderColor:
                                            this.state.cardHolderFirstNameError,
                                        }}
                                        name="cardHolderFirstName"
                                      />
                                    </FormGroup>
                                  </Col>
                                  <Col md={6} xs={12}>
                                    <FormGroup controlId="cardHolderLastNameError">
                                      <ControlLabel>
                                        {
                                          languageConfig[
                                            this.state.default_lang
                                          ].cardholder_lname
                                        }
                                      </ControlLabel>
                                      <FormControl
                                        type="text"
                                        value={this.state.cardHolderLastName}
                                        placeholder={
                                          languageConfig[
                                            this.state.default_lang
                                          ].enter_last_name
                                        }
                                        onChange={this.handleChange}
                                        style={{
                                          borderColor:
                                            this.state.cardHolderLastNameError,
                                        }}
                                        name="cardHolderLastName"
                                      />
                                    </FormGroup>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col md={4} xs={12}>
                                    <FormGroup controlId="cardNumberError">
                                      <ControlLabel>
                                        {
                                          languageConfig[
                                            this.state.default_lang
                                          ].credit_card_no
                                        }
                                      </ControlLabel>
                                      <FormControl
                                        type="text"
                                        value={this.state.cardNumber}
                                        placeholder="XXXXXXXXXXXXXXXX"
                                        onChange={this.handleChange}
                                        style={{
                                          borderColor:
                                            this.state.cardNumberError,
                                        }}
                                        name="cardNumber"
                                      />
                                    </FormGroup>
                                  </Col>
                                  <Col md={3} xs={12}>
                                    <FormGroup>
                                      <ControlLabel>
                                        {
                                          languageConfig[
                                            this.state.default_lang
                                          ].expiration_date
                                        }
                                      </ControlLabel>
                                      <Row>
                                        <Col md={6} xs={12} id="cardMonthError">
                                          <FormControl
                                            type="text"
                                            value={this.state.cardMonth}
                                            placeholder="MM"
                                            onChange={this.handleChange}
                                            style={{
                                              borderColor:
                                                this.state.cardMonthError,
                                            }}
                                            name="cardMonth"
                                          />
                                        </Col>
                                        <Col md={6} xs={12} id="cardYearError">
                                          <FormControl
                                            type="text"
                                            value={this.state.cardYear}
                                            placeholder="YY"
                                            onChange={this.handleChange}
                                            style={{
                                              borderColor:
                                                this.state.cardYearError,
                                            }}
                                            name="cardYear"
                                          />
                                        </Col>
                                      </Row>
                                    </FormGroup>
                                  </Col>
                                  <Col md={5} xs={12}>
                                    <FormGroup controlId="securityCodeError">
                                      <ControlLabel>
                                        {
                                          languageConfig[
                                            this.state.default_lang
                                          ].security_code
                                        }
                                      </ControlLabel>
                                      <FormControl
                                        type="text"
                                        value={this.state.securityCode}
                                        placeholder="XXX"
                                        onChange={this.handleChange}
                                        style={{
                                          borderColor:
                                            this.state.securityCodeError,
                                        }}
                                        name="securityCode"
                                      />
                                    </FormGroup>
                                  </Col>
                                </Row>
                              </React.Fragment>
                            ) : null}
                            <Row bsStyle="primary">
                              <Col md={12} xs={12}>
                                <FormGroup>
                                  <ControlLabel>
                                    {
                                      languageConfig[this.state.default_lang]
                                        .billing_address
                                    }
                                  </ControlLabel>
                                </FormGroup>
                              </Col>
                            </Row>
                            <Row>
                              <Col md={4} xs={12} id="addressError">
                                <FormGroup>
                                  <ControlLabel>
                                    {
                                      languageConfig[this.state.default_lang]
                                        .address
                                    }
                                  </ControlLabel>
                                  <FormControl
                                    type="text"
                                    value={this.state.address}
                                    placeholder={
                                      languageConfig[this.state.default_lang]
                                        .address
                                    }
                                    onChange={this.handleChange}
                                    style={{
                                      borderColor: this.state.addressError,
                                    }}
                                    name="address"
                                  />
                                </FormGroup>
                              </Col>
                              <Col md={4} xs={12}>
                                <FormGroup>
                                  <ControlLabel>
                                    {
                                      languageConfig[this.state.default_lang]
                                        .address2
                                    }
                                  </ControlLabel>
                                  <FormControl
                                    type="text"
                                    value={this.state.address2}
                                    placeholder={
                                      languageConfig[this.state.default_lang]
                                        .address2
                                    }
                                    onChange={this.handleChange}
                                    name="address2"
                                  />
                                </FormGroup>
                              </Col>
                              <Col md={4} xs={12}>
                                <FormGroup>
                                  <ControlLabel>
                                    {
                                      languageConfig[this.state.default_lang]
                                        .city
                                    }
                                  </ControlLabel>
                                  <FormControl
                                    type="text"
                                    value={this.state.city}
                                    placeholder={
                                      languageConfig[this.state.default_lang]
                                        .city
                                    }
                                    onChange={this.handleChange}
                                    style={{
                                      borderColor: this.state.cityError,
                                    }}
                                    name="city"
                                  />
                                </FormGroup>
                              </Col>
                            </Row>
                            <Row>
                              {this.state.paymentMethod == "card" ? (
                                <Col md={4} xs={12} id="stateError">
                                  <FormGroup>
                                    <ControlLabel>
                                      {
                                        languageConfig[this.state.default_lang]
                                          .state
                                      }
                                    </ControlLabel>
                                    <FormControl
                                      type="text"
                                      value={this.state.state}
                                      placeholder={
                                        languageConfig[this.state.default_lang]
                                          .state
                                      }
                                      onChange={this.handleChange}
                                      style={{
                                        borderColor: this.state.stateError,
                                      }}
                                      name="state"
                                    />
                                  </FormGroup>
                                </Col>
                              ) : (
                                <Col
                                  md={4}
                                  xs={12}
                                  className="autocompleted"
                                  id="stateError"
                                >
                                  <FormGroup>
                                    <ControlLabel>
                                      {
                                        languageConfig[this.state.default_lang]
                                          .state
                                      }
                                    </ControlLabel>
                                    <ReactAutocomplete
                                      inputProps={{
                                        style: {
                                          borderColor: this.state.stateError,
                                        },
                                      }}
                                      items={this.state.stateList}
                                      getItemValue={(item) => item.state}
                                      renderGroup={(item) => item.state}
                                      renderItem={(item, isHighlighted) => (
                                        <div
                                          key={item.cityID}
                                          style={{
                                            background: isHighlighted
                                              ? "lightgray"
                                              : "white",
                                          }}
                                        >
                                          {item.state}
                                        </div>
                                      )}
                                      renderMenu={(items, value) => (
                                        <div className="menu">
                                          {items.length === 0 ? (
                                            <div className="item">
                                              No matches for {value}
                                            </div>
                                          ) : (
                                            items
                                          )}
                                        </div>
                                      )}
                                      value={this.state.stateName}
                                      onChange={this.onChangeState}
                                      onSelect={(stateName, item) =>
                                        this.setState({
                                          stateName,
                                          state: item.stateAbbr,
                                          stateError: "",
                                        })
                                      }
                                      autoComplete={false}
                                    />
                                  </FormGroup>
                                </Col>
                              )}
                              <Col md={4} xs={12} id="zipError">
                                <FormGroup>
                                  <ControlLabel>
                                    {
                                      languageConfig[this.state.default_lang]
                                        .zip_code
                                    }
                                  </ControlLabel>
                                  <FormControl
                                    type="text"
                                    value={this.state.zip}
                                    placeholder={
                                      languageConfig[this.state.default_lang]
                                        .zip_code
                                    }
                                    onChange={this.handleChange}
                                    style={{ borderColor: this.state.zipError }}
                                    name="zip"
                                  />
                                </FormGroup>
                              </Col>
                              <Col md={4} xs={12} id="phoneError">
                                <FormGroup>
                                  <ControlLabel>
                                    {
                                      languageConfig[this.state.default_lang]
                                        .phone_no
                                    }
                                  </ControlLabel>
                                  <NumberFormat
                                    format="###-###-####"
                                    mask="_"
                                    className="form-control"
                                    name="phone"
                                    placeholder={
                                      languageConfig[this.state.default_lang]
                                        .enter_phone_no
                                    }
                                    style={{
                                      borderColor: this.state.phoneError,
                                    }}
                                    value={this.state.phone}
                                    onChange={this.handleChange}
                                  />
                                </FormGroup>
                              </Col>
                            </Row>
                            <Row>
                              {this.state.show_charity == "enable" &&
                                this.state.charityOption == "enable" && (
                                  <Col
                                    md={4}
                                    xs={12}
                                    className="autocompletedCharity"
                                  >
                                    <ControlLabel>Charity:</ControlLabel>
                                    <br />
                                    <ReactAutocomplete
                                      inputProps={{
                                        style: {
                                          borderColor:
                                            this.state.userEmailError,
                                        },
                                      }}
                                      items={
                                        this.state.charity
                                          ? this.state.charity
                                          : []
                                      }
                                      shouldItemRender={(item, value) =>
                                        item.charity_name
                                          .toLowerCase()
                                          .indexOf(value.toLowerCase()) > -1
                                      }
                                      getItemValue={(item) => item.charity_name}
                                      renderItem={(item, highlighted) => (
                                        <div
                                          className="form-group"
                                          key={item.charity_id}
                                          data-key={item.charity_id}
                                          style={{
                                            backgroundColor: highlighted
                                              ? "#eee"
                                              : "transparent",
                                          }}
                                        >
                                          {item.charity_name}
                                        </div>
                                      )}
                                      value={this.state.charity_name}
                                      onChange={this.onChangeCharity}
                                      onSelect={(charity_name, item) =>
                                        this.setState({
                                          charity_name,
                                          charity_id: item.charity_id,
                                        })
                                      }
                                      autoComplete={false}
                                    />
                                  </Col>
                                )}
                            </Row>
                          </Col>
                        ) : null}
                      </Row>
                    )}
                  </div>
                </div>
              ) : (
                /*<div className="panel">
                  <header className="panel-heading">{languageConfig[this.state.default_lang].biling_information}</header>
                  <div className="panel-body">
                    <Row>
                      <Col md={12} xs={12}>
                        <Row>
                          <Col md={6} xs={12}>
                            <FormGroup>
                              <ControlLabel>{languageConfig[this.state.default_lang].first_name} </ControlLabel>
                              <FormControl
                                type="text"
                                value={this.state.cardHolderFirstName}
                                placeholder={languageConfig[this.state.default_lang].enter_first_name}
                                onChange={this.handleChange}
                                style={{
                                  borderColor: this.state
                                    .cardHolderFirstNameError
                                }}
                                name="cardHolderFirstName"
                              />
                            </FormGroup>
                          </Col>
                          <Col md={6} xs={12}>
                            <FormGroup>
                              <ControlLabel>{languageConfig[this.state.default_lang].last_name}</ControlLabel>
                              <FormControl
                                type="text"
                                value={this.state.cardHolderLastName}
                                placeholder={languageConfig[this.state.default_lang].enter_last_name}
                                onChange={this.handleChange}
                                style={{
                                  borderColor: this.state
                                    .cardHolderLastNameError
                                }}
                                name="cardHolderLastName"
                              />
                            </FormGroup>
                          </Col>
                        </Row>

                        <Row bsStyle="primary">
                          <Col md={12} xs={12}>
                            <FormGroup>
                              <ControlLabel>{languageConfig[this.state.default_lang].billing_address}</ControlLabel>
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col md={4} xs={12} id="addressError">
                            <FormGroup>
                              <ControlLabel>{languageConfig[this.state.default_lang].address}</ControlLabel>
                              <FormControl
                                type="text"
                                value={this.state.address}
                                placeholder={languageConfig[this.state.default_lang].address}
                                onChange={this.handleChange}
                                style={{ borderColor: this.state.addressError }}
                                name="address"
                              />
                            </FormGroup>
                          </Col>
                          <Col md={4} xs={12}>
                            <FormGroup>
                              <ControlLabel>{languageConfig[this.state.default_lang].address2}</ControlLabel>
                              <FormControl
                                type="text"
                                value={this.state.address2}
                                placeholder={languageConfig[this.state.default_lang].address2}
                                onChange={this.handleChange}
                                name="address2"
                              />
                            </FormGroup>
                          </Col>
                          <Col md={4} xs={12}>
                            <FormGroup controlId="cityError">
                              <ControlLabel>{languageConfig[this.state.default_lang].city}</ControlLabel>
                              <FormControl
                                type="text"
                                value={this.state.city}
                                placeholder={languageConfig[this.state.default_lang].city}
                                onChange={this.handleChange}
                                style={{ borderColor: this.state.cityError }}
                                name="city"
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col md={4} xs={12}>
                            <FormGroup controlId="borderColor">
                              <ControlLabel>{languageConfig[this.state.default_lang].state}</ControlLabel>
                              <FormControl
                                type="text"
                                value={this.state.state}
                                placeholder={languageConfig[this.state.default_lang].state}
                                onChange={this.handleChange}
                                style={{ borderColor: this.state.stateError }}
                                name="state"
                              />
                            </FormGroup>
                          </Col>
                          <Col md={4} xs={12} id="zipError">
                            <FormGroup>
                              <ControlLabel>{languageConfig[this.state.default_lang].zip_code}</ControlLabel>
                              <FormControl
                                type="text"
                                value={this.state.zip}
                                placeholder={languageConfig[this.state.default_lang].zip_code}
                                onChange={this.handleChange}
                                style={{ borderColor: this.state.zipError }}
                                name="zip"
                              />
                            </FormGroup>
                          </Col>
                          <Col md={4} xs={12} id="phoneError">
                            <FormGroup>
                              <ControlLabel>{languageConfig[this.state.default_lang].phone_no}</ControlLabel>
                              <NumberFormat
                                format="###-###-####"
                                mask="_"
                                className="form-control"
                                name="phone"
                                placeholder={languageConfig[this.state.default_lang].enter_phone_no}
                                style={{ borderColor: this.state.phoneError }}
                                value={this.state.phone}
                                onChange={this.handleChange}
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </div>
                </div>*/ ""
              )}

              {total - this.state.creditAmount <= 0 ? (
                <div className="panel">
                  <header className="panel-heading">
                    {languageConfig[this.state.default_lang].biling_information}
                  </header>
                  <div className="panel-body">
                    <Row>
                      <Col md={12} xs={12}>
                        <Row>
                          <Col md={6} xs={12}>
                            <FormGroup>
                              <ControlLabel>
                                {
                                  languageConfig[this.state.default_lang]
                                    .first_name
                                }{" "}
                              </ControlLabel>
                              <FormControl
                                type="text"
                                value={this.state.cardHolderFirstName}
                                placeholder={
                                  languageConfig[this.state.default_lang]
                                    .enter_first_name
                                }
                                onChange={this.handleChange}
                                style={{
                                  borderColor:
                                    this.state.cardHolderFirstNameError,
                                }}
                                name="cardHolderFirstName"
                              />
                            </FormGroup>
                          </Col>
                          <Col md={6} xs={12}>
                            <FormGroup>
                              <ControlLabel>
                                {
                                  languageConfig[this.state.default_lang]
                                    .last_name
                                }
                              </ControlLabel>
                              <FormControl
                                type="text"
                                value={this.state.cardHolderLastName}
                                placeholder={
                                  languageConfig[this.state.default_lang]
                                    .enter_last_name
                                }
                                onChange={this.handleChange}
                                style={{
                                  borderColor:
                                    this.state.cardHolderLastNameError,
                                }}
                                name="cardHolderLastName"
                              />
                            </FormGroup>
                          </Col>
                        </Row>

                        <Row bsStyle="primary">
                          <Col md={12} xs={12}>
                            <FormGroup>
                              <ControlLabel>
                                {
                                  languageConfig[this.state.default_lang]
                                    .billing_address
                                }
                              </ControlLabel>
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col md={4} xs={12}>
                            <FormGroup
                              controlId="addressError"
                              id="addressError"
                            >
                              <ControlLabel>
                                {
                                  languageConfig[this.state.default_lang]
                                    .address
                                }
                              </ControlLabel>
                              <FormControl
                                type="text"
                                value={this.state.address}
                                placeholder={
                                  languageConfig[this.state.default_lang]
                                    .address
                                }
                                onChange={this.handleChange}
                                style={{ borderColor: this.state.addressError }}
                                name="address"
                              />
                            </FormGroup>
                          </Col>
                          <Col md={4} xs={12}>
                            <FormGroup>
                              <ControlLabel>
                                {
                                  languageConfig[this.state.default_lang]
                                    .address2
                                }
                              </ControlLabel>
                              <FormControl
                                type="text"
                                value={this.state.address2}
                                placeholder={
                                  languageConfig[this.state.default_lang]
                                    .address2
                                }
                                onChange={this.handleChange}
                                name="address2"
                              />
                            </FormGroup>
                          </Col>
                          <Col md={4} xs={12}>
                            <FormGroup controlId="cityError">
                              <ControlLabel>
                                {languageConfig[this.state.default_lang].city}
                              </ControlLabel>
                              <FormControl
                                type="text"
                                value={this.state.city}
                                placeholder={
                                  languageConfig[this.state.default_lang].city
                                }
                                onChange={this.handleChange}
                                style={{ borderColor: this.state.cityError }}
                                name="city"
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col md={4} xs={12} id="stateError">
                            <FormGroup>
                              <ControlLabel>
                                {languageConfig[this.state.default_lang].state}
                              </ControlLabel>
                              <FormControl
                                type="text"
                                value={this.state.state}
                                placeholder={
                                  languageConfig[this.state.default_lang].state
                                }
                                onChange={this.handleChange}
                                style={{ borderColor: this.state.stateError }}
                                name="state"
                              />
                            </FormGroup>
                          </Col>
                          <Col md={4} xs={12}>
                            <FormGroup controlId="zipError">
                              <ControlLabel>
                                {
                                  languageConfig[this.state.default_lang]
                                    .zip_code
                                }
                              </ControlLabel>
                              <FormControl
                                type="text"
                                value={this.state.zip}
                                placeholder={
                                  languageConfig[this.state.default_lang]
                                    .zip_code
                                }
                                onChange={this.handleChange}
                                style={{ borderColor: this.state.zipError }}
                                name="zip"
                              />
                            </FormGroup>
                          </Col>
                          <Col md={4} xs={12}>
                            <FormGroup controlId="phoneError">
                              <ControlLabel>
                                {
                                  languageConfig[this.state.default_lang]
                                    .phone_no
                                }
                              </ControlLabel>
                              <NumberFormat
                                format="###-###-####"
                                mask="_"
                                className="form-control"
                                name="phone"
                                placeholder={
                                  languageConfig[this.state.default_lang]
                                    .enter_phone_no
                                }
                                style={{ borderColor: this.state.phoneError }}
                                value={this.state.phone}
                                onChange={this.handleChange}
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </div>
                </div>
              ) : (
                ""
              )}
              {this.state.show_shipable == "yes" && sendAsGift != 1 && (
                <div className="panel">
                  <header className="panel-heading">
                    {languageConfig[this.state.default_lang].shipping_address}
                  </header>
                  <div className="panel-body">
                    <Row>
                      {this.state.paymentMethod != "paypal" && (
                        <Col md={6} xs={12}>
                          <FormGroup>
                            <Checkbox
                              name="sameAsBillingAddress"
                              onClick={this.sameAsBillingAddress}
                            >
                              {
                                languageConfig[this.state.default_lang]
                                  .same_billing_addres
                              }
                            </Checkbox>
                          </FormGroup>
                        </Col>
                      )}
                    </Row>

                    {this.state.sameAsBillingAddress == 0 && (
                      <Row>
                        <Col md={6} xs={12}>
                          <FormGroup controlId="shippingFirstNameError">
                            <ControlLabel>
                              {
                                languageConfig[this.state.default_lang]
                                  .first_name
                              }{" "}
                            </ControlLabel>
                            <FormControl
                              type="text"
                              value={this.state.shippingFirstName}
                              placeholder={
                                languageConfig[this.state.default_lang]
                                  .enter_first_name
                              }
                              onChange={this.handleChange}
                              style={{
                                borderColor: this.state.shippingFirstNameError,
                              }}
                              name="shippingFirstName"
                            />
                          </FormGroup>
                        </Col>
                        <Col md={6} xs={12}>
                          <FormGroup controlId="shippingLastNameError">
                            <ControlLabel>
                              {
                                languageConfig[this.state.default_lang]
                                  .last_name
                              }
                            </ControlLabel>
                            <FormControl
                              type="text"
                              value={this.state.shippingLastName}
                              placeholder={
                                languageConfig[this.state.default_lang]
                                  .enter_last_name
                              }
                              onChange={this.handleChange}
                              style={{
                                borderColor: this.state.shippingLastNameError,
                              }}
                              name="shippingLastName"
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                    )}
                    {this.state.sameAsBillingAddress == 0 && (
                      <Row>
                        <Col md={4} xs={12}>
                          <FormGroup controlId="shippingAddressError">
                            <ControlLabel>
                              {languageConfig[this.state.default_lang].address}
                            </ControlLabel>
                            <FormControl
                              type="text"
                              value={this.state.shippingAddress}
                              placeholder={
                                languageConfig[this.state.default_lang].address
                              }
                              onChange={this.handleChange}
                              style={{
                                borderColor: this.state.shippingAddressError,
                              }}
                              name="shippingAddress"
                            />
                          </FormGroup>
                        </Col>
                        <Col md={4} xs={12}>
                          <FormGroup>
                            <ControlLabel>
                              {languageConfig[this.state.default_lang].address2}
                            </ControlLabel>
                            <FormControl
                              type="text"
                              value={this.state.shippingAddress2}
                              placeholder={
                                languageConfig[this.state.default_lang].address2
                              }
                              onChange={this.handleChange}
                              name="shippingAddress2"
                            />
                          </FormGroup>
                        </Col>
                        <Col md={4} xs={12}>
                          <FormGroup controlId="shippingCityError">
                            <ControlLabel>
                              {languageConfig[this.state.default_lang].city}
                            </ControlLabel>
                            <FormControl
                              type="text"
                              value={this.state.shippingCity}
                              placeholder={
                                languageConfig[this.state.default_lang].city
                              }
                              onChange={this.handleChange}
                              style={{
                                borderColor: this.state.shippingCityError,
                              }}
                              name="shippingCity"
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                    )}
                    {this.state.sameAsBillingAddress == 0 && (
                      <Row>
                        <Col md={4} xs={12}>
                          <FormGroup controlId="shippingStateError">
                            <ControlLabel>
                              {languageConfig[this.state.default_lang].state}
                            </ControlLabel>
                            <FormControl
                              type="text"
                              value={this.state.shippingState}
                              placeholder={
                                languageConfig[this.state.default_lang].state
                              }
                              onChange={this.handleChange}
                              style={{
                                borderColor: this.state.shippingStateError,
                              }}
                              name="shippingState"
                            />
                          </FormGroup>
                        </Col>
                        <Col md={4} xs={12}>
                          <FormGroup controlId="shippingzipError">
                            <ControlLabel>
                              {languageConfig[this.state.default_lang].zip_code}
                            </ControlLabel>
                            <FormControl
                              type="text"
                              value={this.state.shippingzip}
                              placeholder={
                                languageConfig[this.state.default_lang].zip_code
                              }
                              onChange={this.handleChange}
                              style={{
                                borderColor: this.state.shippingzipError,
                              }}
                              name="shippingzip"
                            />
                          </FormGroup>
                        </Col>
                        <Col md={4} xs={12} id="shippingPhoneError">
                          <FormGroup>
                            <ControlLabel>
                              {languageConfig[this.state.default_lang].phone_no}
                            </ControlLabel>
                            <NumberFormat
                              format="###-###-####"
                              mask="_"
                              className="form-control"
                              name="shippingPhone"
                              placeholder={
                                languageConfig[this.state.default_lang]
                                  .enter_phone_no
                              }
                              style={{
                                borderColor: this.state.shippingPhoneError,
                              }}
                              value={this.state.shippingPhone}
                              onChange={this.handleChange}
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                    )}
                  </div>
                </div>
              )}
              {sendAsGift == 1 && (
                <div className="panel">
                  <header className="panel-heading">
                    {
                      languageConfig[this.state.default_lang]
                        .gift_recipient_info
                    }
                  </header>
                  <div className="panel-body">
                    <Row>
                      <Col md={12} xs={12}>
                        <FormGroup>
                          <Checkbox
                            onChange={this.handleBillingInfo}
                            name="giftBillingInfo"
                            defaultChecked={this.state.giftBillingInfo}
                          >
                            {
                              languageConfig[this.state.default_lang]
                                .same_billing_addres
                            }
                          </Checkbox>
                        </FormGroup>
                      </Col>
                    </Row>
                    {!this.state.giftBillingInfo && (
                      <Row>
                        <Col md={6} xs={12}>
                          <FormGroup controlId="giftFirstNameError">
                            <ControlLabel>
                              {
                                languageConfig[this.state.default_lang]
                                  .first_name
                              }
                            </ControlLabel>
                            <FormControl
                              type="text"
                              value={this.state.giftFirstName}
                              placeholder={
                                languageConfig[this.state.default_lang]
                                  .enter_first_name
                              }
                              onChange={this.handleChange}
                              style={{
                                borderColor: this.state.giftFirstNameError,
                              }}
                              name="giftFirstName"
                            />
                          </FormGroup>
                        </Col>
                        <Col md={6} xs={12}>
                          <FormGroup controlId="giftLastNameError">
                            <ControlLabel>
                              {
                                languageConfig[this.state.default_lang]
                                  .last_name
                              }
                            </ControlLabel>
                            <FormControl
                              type="text"
                              value={this.state.giftLastName}
                              placeholder={
                                languageConfig[this.state.default_lang]
                                  .enter_last_name
                              }
                              onChange={this.handleChange}
                              style={{
                                borderColor: this.state.giftLastNameError,
                              }}
                              name="giftLastName"
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                    )}
                    {!this.state.giftBillingInfo && (
                      <Row>
                        <Col md={6} xs={12}>
                          <FormGroup controlId="giftAddressError">
                            <ControlLabel>
                              {languageConfig[this.state.default_lang].address}
                            </ControlLabel>
                            <FormControl
                              type="text"
                              value={this.state.giftAddress}
                              placeholder={
                                languageConfig[this.state.default_lang].address
                              }
                              onChange={this.handleChange}
                              style={{
                                borderColor: this.state.giftAddressError,
                              }}
                              name="giftAddress"
                            />
                          </FormGroup>
                        </Col>
                        <Col md={6} xs={12}>
                          <FormGroup controlId="giftCityError">
                            <ControlLabel>
                              {languageConfig[this.state.default_lang].city}
                            </ControlLabel>
                            <FormControl
                              type="text"
                              value={this.state.giftCity}
                              placeholder={
                                languageConfig[this.state.default_lang].city
                              }
                              onChange={this.handleChange}
                              style={{ borderColor: this.state.giftCityError }}
                              name="giftCity"
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                    )}
                    {!this.state.giftBillingInfo && (
                      <Row>
                        <Col md={6} xs={12}>
                          <FormGroup controlId="giftStateError">
                            <ControlLabel>
                              {languageConfig[this.state.default_lang].state}
                            </ControlLabel>
                            <FormControl
                              type="text"
                              value={this.state.giftState}
                              placeholder={
                                languageConfig[this.state.default_lang].state
                              }
                              onChange={this.handleChange}
                              style={{ borderColor: this.state.giftStateError }}
                              name="giftState"
                            />
                          </FormGroup>
                        </Col>
                        <Col md={6} xs={12}>
                          <FormGroup controlId="giftZipError">
                            <ControlLabel>
                              {languageConfig[this.state.default_lang].zip_code}
                            </ControlLabel>
                            <FormControl
                              type="text"
                              value={this.state.giftZip}
                              placeholder={
                                languageConfig[this.state.default_lang].zip_code
                              }
                              onChange={this.handleChange}
                              style={{ borderColor: this.state.giftZipError }}
                              name="giftZip"
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                    )}
                    <Row>
                      <Col md={12} xs={12}>
                        <header className="panel-heading">
                          {languageConfig[this.state.default_lang].get_details}
                        </header>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={6} xs={12}>
                        <FormGroup controlId="recipientNameError">
                          <ControlLabel>
                            {
                              languageConfig[this.state.default_lang]
                                .recipent_name
                            }
                          </ControlLabel>
                          <FormControl
                            type="text"
                            value={
                              this.state.recipientName
                                ? this.state.recipientName
                                : recipientName
                            }
                            placeholder={
                              languageConfig[this.state.default_lang].enter_name
                            }
                            onChange={this.handleChange}
                            style={{
                              borderColor: this.state.recipientNameError,
                            }}
                            name="recipientName"
                          />
                        </FormGroup>
                      </Col>
                      <Col md={6} xs={12}>
                        <FormGroup controlId="recipientEmailError">
                          <ControlLabel>
                            {
                              languageConfig[this.state.default_lang]
                                .recipent_email
                            }
                          </ControlLabel>
                          <FormControl
                            type="text"
                            value={
                              this.state.recipientEmail
                                ? this.state.recipientEmail
                                : recipientEmail
                            }
                            placeholder={
                              languageConfig[this.state.default_lang]
                                .enter_email
                            }
                            onChange={this.handleChange}
                            style={{
                              borderColor: this.state.recipientEmailError,
                            }}
                            name="recipientEmail"
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={12} md={12}>
                        <FormGroup controlId="personalMessageError">
                          <ControlLabel>
                            {
                              languageConfig[this.state.default_lang]
                                .personal_message
                            }
                          </ControlLabel>
                          <FormControl
                            componentClass="textarea"
                            name="personalMessage"
                            value={
                              this.state.personalMessage
                                ? this.state.personalMessage
                                : personalMessage
                            }
                            onChange={this.handleChange}
                            style={{
                              borderColor: this.state.personalMessageError,
                            }}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                  </div>
                </div>
              )}
              {this.state.willcall && this.state.willcall == "yes" ? (
                <React.Fragment>
                  <div className="panel">
                    <header className="panel-heading">
                      {
                        languageConfig[this.state.default_lang]
                          .pick_up_information
                      }
                    </header>
                    <div className="panel-body">
                      <Row>
                        <Col md={6} xs={12}>
                          {
                            languageConfig[this.state.default_lang]
                              .pick_up_notes1
                          }
                          <FormGroup>
                            <Checkbox
                              name="sameAsBillingName"
                              onClick={this.sameAsBillingName}
                            >
                              {
                                languageConfig[this.state.default_lang]
                                  .same_billing_name
                              }
                            </Checkbox>
                          </FormGroup>
                          <hr />
                          {languageConfig[this.state.default_lang].note}:{" "}
                          {
                            languageConfig[this.state.default_lang]
                              .pick_up_notes2
                          }
                        </Col>

                        {this.state.sameAsBillingName == "0" ? (
                          <Col md={6} xs={12}>
                            <FormGroup controlId="pickupFirstNameError">
                              <ControlLabel>
                                {
                                  languageConfig[this.state.default_lang]
                                    .first_name
                                }{" "}
                              </ControlLabel>
                              <FormControl
                                type="text"
                                value={this.state.pickupFirstName}
                                placeholder={
                                  languageConfig[this.state.default_lang]
                                    .enter_first_name
                                }
                                onChange={this.handleChange}
                                style={{
                                  borderColor: this.state.pickupFirstNameError,
                                }}
                                name="pickupFirstName"
                              />
                            </FormGroup>
                            <FormGroup controlId="pickupLastNameError">
                              <ControlLabel>
                                {
                                  languageConfig[this.state.default_lang]
                                    .last_name
                                }{" "}
                              </ControlLabel>
                              <FormControl
                                type="text"
                                value={this.state.pickupLastName}
                                placeholder={
                                  languageConfig[this.state.default_lang]
                                    .enter_last_name
                                }
                                onChange={this.handleChange}
                                style={{
                                  borderColor: this.state.pickupLastNameError,
                                }}
                                name="pickupLastName"
                              />
                            </FormGroup>
                          </Col>
                        ) : null}
                      </Row>
                    </div>
                  </div>
                </React.Fragment>
              ) : (
                ""
              )}
              <Col md={12} xs={12}>
                {this.state.CheckoutNotes && this.state.CheckoutNotes !== "" ? (
                  <React.Fragment>
                    {ReactHtmlParser(this.state.CheckoutNotes)}
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <Col md={12} xs={12}>
                      <FormGroup>
                        <b>
                          ***
                          {
                            languageConfig[this.state.default_lang]
                              .tax_rate_applied_msg
                          }
                          ***
                        </b>
                      </FormGroup>
                      {this.state.default_lang == "en" ? (
                        <FormGroup>
                          By completing this order, you agree to the{" "}
                          <Link replace to="">
                            offer terms
                          </Link>{" "}
                          and our{" "}
                          <Link replace to="">
                            terms and conditions
                          </Link>
                          .
                        </FormGroup>
                      ) : (
                        <FormGroup>
                          En complétant votre achat, vous acceptez les modalités
                          et conditions afférentes, telles qu'elles sont
                          formulées, à l'utilisation de notre site.
                        </FormGroup>
                      )}
                    </Col>
                  </React.Fragment>
                )}
              </Col>
              {total > 0 &&
              ((this.state.checkoutType == "guest" &&
                !this.state.guestemail &&
                this.state.email != "" &&
                this.state.dob != "") ||
                !isEmpty(localStorage.getItem("user"))) ? (
                <Row className="BtnRow">
                  <Col md={12} xs={12} className="text-center">
                    {/*this.state.paymentMethod === "paypal1" ? (
                      ((this.state.checkoutType == 'guest' && !this.state.guestemail && this.state.email != '' && this.state.dob != '') ||  !isEmpty(localStorage.getItem("user"))) &&
                        <PaypalButton
                          env={env}
                          client={client}
                          shipping={2}
                          currency={currency}
                          total={(total - this.state.creditAmount).toFixed(2)}
                          item={cartItemPaypal}
                          details={{subtotal: subCartOfferPrice.toFixed(2), tax: (total.toFixed(2) - subCartOfferPrice.toFixed(2) - subTotalShipping.toFixed(2)).toFixed(2), shipping: subTotalShipping.toFixed(2), handling_fee: "0.00", shipping_discount: "0.00", insurance: "0.00"}}
                          onError={onError}
                          onSuccess={onSuccess}
                          onCancel={onCancel}  
                        />
                    ) :*/}
                    {this.state.paymentMethod === "card" ||
                    this.state.paymentMethod === "chase" ||
                    this.state.paymentMethod === "payway" ||
                    this.state.paymentMethod === "paypal" ||
                    this.state.paymentMethod === "stripe" ? (
                      <Button
                        style={{
                          backgroundColor:
                            this.state.hover && this.state.hoverID == "paynow"
                              ? this.state.mouseover_color
                              : this.state.button_color
                              ? this.state.button_color
                              : "#77C84E",
                        }}
                        data-id={"paynow"}
                        onMouseEnter={this.hoverOn}
                        onMouseLeave={this.hoverOff}
                        bsStyle="success"
                        type="submit"
                        onClick={this.totalAmount.bind(
                          this,
                          total - this.state.creditAmount
                        )}
                        disabled={this.props.paying || !this.state.isValidateRemainingQty}
                      >
                        {languageConfig[this.state.default_lang].pay_now}
                      </Button>
                    ) : (
                      <Button
                        style={{
                          backgroundColor:
                            this.state.hover &&
                            this.state.hoverID == "checkouts"
                              ? this.state.mouseover_color
                              : this.state.button_color
                              ? this.state.button_color
                              : "#77C84E",
                        }}
                        data-id={"checkouts"}
                        onMouseEnter={this.hoverOn}
                        onMouseLeave={this.hoverOff}
                        bsStyle="success"
                        disabled={!this.state.isValidateRemainingQty}
                        type="submit"
                      >
                        {languageConfig[this.state.default_lang].checkout}
                      </Button>
                    )}
                  </Col>
                </Row>
              ) : (
                <Row className="BtnRow">
                  <Col md={12} xs={12} className="text-center">
                    <Button
                      style={{
                        backgroundColor:
                          this.state.hover && this.state.hoverID == "checkout"
                            ? this.state.mouseover_color
                            : this.state.button_color
                            ? this.state.button_color
                            : "#77C84E",
                      }}
                      data-id={"checkout"}
                      onMouseEnter={this.hoverOn}
                      onMouseLeave={this.hoverOff}
                      bsStyle="success"
                      type="submit"
                      disabled={!this.state.isValidateRemainingQty}
                    >
                      {languageConfig[this.state.default_lang].checkout}
                    </Button>
                  </Col>
                </Row>
              )}
              {this.state.show &&
                this.state.alertMessage !== "" &&
                this.state.alertMessage !== undefined &&
                this.state.promoStatus == 0 && (
                  <div className="col-lg-12">
                    <Alert
                      bsStyle={this.state.msgType}
                      onDismiss={this.handleDismiss}
                    >
                      <strong>Message:</strong> {this.state.alertMessage}
                    </Alert>
                  </div>
                )}
            </div>
          </form>
        )}
        <hr />
      </div>
    );
  }
}

// export default Dashboard;

Checkout.propTypes = {
  getCartDetail: PropTypes.func.isRequired,
  checkout: PropTypes.func.isRequired,
  getFrontPaymentSetting: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  error: state.frontReducer.error,
  paying: state.frontReducer.paying,
  cartError: state.frontReducer.cartError,
  checkoutStatus: state.frontReducer.checkoutStatus,
  creditAmount: state.frontReducer.creditAmount,
  cartDetail: state.frontReducer.cartDetail,
  alertType: state.alertsReducer.alertType,
  message: state.alertsReducer.message,
  promoStatus: state.frontReducer.promoStatus,
  promoError: state.frontReducer.promoError,
  paymentSetting: state.paymentSettingReducer.paymentSetting,
  getCharity: state.frontReducer.getCharity,
  removeStatus: state.frontReducer.promoRemoveStatus,
  cityList: state.frontReducer.allCityList,
  taxdata: state.frontReducer.taxRate,
  StateList: state.frontReducer.SearchStateList,
  CheckEmail: state.frontReducer.GuestEmail,
  StatusGuestEmail: state.frontReducer.StatusGuestEmail,
});

export default compose(
  connect(mapStateToProps, {
    getCartDetail,
    getFrontPaymentSetting,
    checkout,
    renderAlert,
    clearAlert,
    applyPromoCode,
    removePromoCode,
    storeCredit,
    getcharityList,
    getAllSiteCity,
    getSearchState,
    taxRate,
    CheckGuestEmail,
    RegGuestEmail,
  })
)(Checkout);


// WEBPACK FOOTER //
// ./src/app/views/frontend/dashboard/Checkout.js